/**
 * CAMO COSMETICS — LUXURY WEB & SKINAI ENGINE
 * MULTI-PLATFORM CART ENGINE (SHOPIFY + WOOCOMMERCE + STANDALONE)
 */

// CAMO Global Namespace
window.camoApp = window.camoApp || {};

let heroCurrentIndex = 0;
let heroAutoplayTimer = null;
const HERO_AUTOPLAY_DELAY = 5500;

function camoGetAssetUrl(filename) {
  const cleanName = filename.replace(/^assets\//, '');
  if (typeof window !== 'undefined' && window.CAMO_WP && window.CAMO_WP.assets_url) {
    return window.CAMO_WP.assets_url + cleanName;
  }
  return 'assets/' + cleanName;
}

// Product slug to WooCommerce ID mapping
const CAMO_PRODUCT_IDS = {
  'camo-calm-mist': 732,
  'camo-calm-serum': 724,
  'reti-glow': 667,
  'niacinamide': 642,
  'peeling-enzimatico': 0,
  'purifying-mousse': 616,
  'lip-mask': 407,
};

const CAMO_PRODUCTS = {
  'camo-calm-mist': {
    id: 'camo-calm-mist',
    wc_id: 732,
    name: 'CAMO CALM Barrier Defense Mist',
    subtitle: 'Prebióticos, Ácido Hialurónico & Sodium PCA',
    price: 27.00,
    volume: '100 ml',
    get image() { return camoGetAssetUrl('product_camo_calm_mist.png'); },
    category: 'Bruma Facial & Barrera Cutánea',
    rating: 4.96,
    reviewCount: 52,
    shortDesc: 'Bruma facial ultraligera que hidrata, refresca y fortalece la barrera cutánea al instante.',
    fullDesc: 'Refresca, hidrata y protege tu piel con CAMO CALM Microbiome Prebiotics Barrier Defense Mist, una bruma facial formulada para fortalecer la barrera cutánea y favorecer el equilibrio del microbioma.',
    benefits: ['Hidrata y refresca al instante', 'Fortalece la barrera cutánea', 'Equilibra el microbioma', 'Apta para todo tipo de piel'],
    howToUse: 'Pulverizar sobre el rostro a 20-30 cm con los ojos cerrados tras la limpieza, antes/después del maquillaje o durante el día.',
    keyIngredients: [
      { name: 'Prebióticos Bioactivos', desc: 'Equilibran el microbioma cutáneo y fortalecen la barrera natural.' },
      { name: 'Ácido Hialurónico', desc: 'Aporte de hidratación inmediata y elasticidad prolongada.' },
      { name: 'Sodium PCA', desc: 'Factor de hidratación natural (NMF) que retiene el agua celular.' }
    ]
  },
  'camo-calm-serum': {
    id: 'camo-calm-serum',
    wc_id: 724,
    name: 'CAMO CALM Prebiotics Serum',
    subtitle: 'Reparador de la Barrera Cutánea & Prebióticos Bio',
    price: 25.00,
    volume: '30 ml',
    get image() { return camoGetAssetUrl('product_camo_calm_serum.png'); },
    category: 'Tratamiento Calma & Barrera',
    rating: 4.94,
    reviewCount: 48,
    shortDesc: 'Sérum textura gel que repara la barrera cutánea, refuerza el microbioma y calma rojeces.',
    fullDesc: 'Su avanzada fórmula combina prebióticos, ácido hialurónico y Sodium PCA para reparar la barrera cutánea debilitada, calmar la tirantez y devolver suavidad sin sensación grasa.',
    benefits: ['Repara la barrera cutánea', 'Calma tirantez y rojeces', 'Hidratación profunda sin grasa', 'Ideal piel sensible'],
    howToUse: 'Aplicar 2 a 4 gotas sobre la piel limpia y seca del rostro y cuello, mañana y noche.',
    keyIngredients: [
      { name: 'Prebióticos Bioactivos', desc: 'Favorecen el equilibrio del microbioma y reducen la reactividad.' },
      { name: 'Ácido Hialurónico Puro', desc: 'Hidrata en profundidad y suaviza la piel.' },
      { name: 'Sodium PCA', desc: 'Conserva el agua celular evitando la deshidratación.' }
    ]
  },
  'reti-glow': {
    id: 'reti-glow',
    wc_id: 667,
    name: 'Reti-Glow Serum Oil',
    subtitle: 'Bakuchiol 1%, Aceites Naturales de Frambuesa y Arándanos',
    price: 79.00,
    volume: '30 ml',
    get image() { return camoGetAssetUrl('product_reti_glow.png'); },
    category: 'Tratamiento Luminosidad & Firmeza',
    rating: 4.98,
    reviewCount: 142,
    shortDesc: 'Aceite facial botánico con Bakuchiol 1% (alternativa natural al retinol). No fotosensible.',
    fullDesc: 'Tratamiento antiedad global de rápida absorción. El Bakuchiol al 1% estimula la síntesis de colágeno y la renovación celular sin causar irritación ni fotosensibilidad.',
    benefits: ['Reduce líneas de expresión', 'Aumenta elasticidad y firmeza', 'No irrita ni descama', 'Uso día y noche'],
    howToUse: 'Aplicar 3-4 gotas sobre rostro y cuello limpios, mañana y noche.',
    keyIngredients: [
      { name: 'Bakuchiol 1%', desc: 'Retinol vegetal de máxima tolerancia que acelera la renovación celular.' },
      { name: 'Aceite de Frambuesa', desc: 'Rico en Vitamina E y ácidos grasos esenciales omega 3 y 6.' },
      { name: 'Aceite de Semilla de Arándano', desc: 'Potente antioxidante que combate el daño oxidativo.' }
    ]
  },
  'niacinamide': {
    id: 'niacinamide',
    wc_id: 642,
    name: 'Niacinamide Gel Moisturiser',
    subtitle: 'Niacinamida 5%, Ácido Hialurónico & Cafeína',
    price: 49.00,
    volume: '50 ml',
    get image() { return camoGetAssetUrl('product_niacinamide_gel.png'); },
    category: 'Hidratación & Control de Poros',
    rating: 4.91,
    reviewCount: 98,
    shortDesc: 'Gel hidratante ultraligero que equilibra la producción de sebo, atenúa manchas y minimiza poros.',
    fullDesc: 'Fórmula hidratante en gel diseñada para pieles mixtas, grasas o con tendencia a imperfecciones. La Niacinamida al 5% regula el sebo mientras descongestiona la dermis.',
    benefits: ['Controla brillos durante 12h', 'Minimiza apariencia de poros', 'Atenúa manchas post-acné', 'Textura gel invisible'],
    howToUse: 'Extender una pequeña cantidad sobre rostro y cuello tras el sérum, mañana y noche.',
    keyIngredients: [
      { name: 'Niacinamida 5%', desc: 'Vitamina B3 que fortalece la barrera y regula el sebo.' },
      { name: 'Ácido Hialurónico Multimolecular', desc: 'Hidratación sin aportar grasa.' },
      { name: 'Extracto de Cafeína', desc: 'Efecto descongestivo y revitalizante.' }
    ]
  },
  'peeling-enzimatico': {
    id: 'peeling-enzimatico',
    wc_id: 0,
    name: 'Peeling Enzimático Facial',
    subtitle: 'Enzimas de Granada, Papaya & Polvo de Arroz',
    price: 36.00,
    volume: '75 ml',
    get image() { return camoGetAssetUrl('product_peeling_enzimatico.png'); },
    category: 'Exfoliación Suave & Renovación',
    rating: 4.95,
    reviewCount: 67,
    shortDesc: 'Exfoliante no abrasivo que disuelve células muertas mediante acción enzimática botánica.',
    fullDesc: 'Renovador cutáneo biológico sin micropartículas agresivas. Las enzimas naturales de granada y papaya descomponen las células queratinizadas superficiales.',
    benefits: ['Exfoliación no mecánica', 'Apto para pieles con rojeces o acné', 'Luminosidad inmediata', 'Mejora absorción de tratamientos'],
    howToUse: 'Aplicar una fina capa sobre la piel limpia. Dejar actuar 5-7 minutos y retirar con agua tibia.',
    keyIngredients: [
      { name: 'Enzimas de Granada Fermentada', desc: 'Disuelven los enlaces de queratina celular suavemente.' },
      { name: 'Papaína Activa', desc: 'Enzima purificante que limpia el poro en profundidad.' },
      { name: 'Polvo de Arroz Micronizado', desc: 'Aporta suavidad extrema y calma la piel.' }
    ]
  },
  'purifying-mousse': {
    id: 'purifying-mousse',
    wc_id: 616,
    name: 'Purifying Mousse Cleanser',
    subtitle: 'Agua de Rosas, Pepino & Tensioactivos de Coco',
    price: 32.00,
    volume: '150 ml',
    get image() { return camoGetAssetUrl('product_purifying_mousse.png'); },
    category: 'Limpieza Botánica & Frescura',
    rating: 4.89,
    reviewCount: 84,
    shortDesc: 'Espuma limpiadora sedosa que elimina impurezas sin alterar el manto lipídico.',
    fullDesc: 'Mousse limpiadora con pH 5.5 formulada con hidrolato de rosas biológicas y extracto de pepino. Suave y reconfortante, limpia en profundidad sin sensación de tirantez.',
    benefits: ['Limpieza profunda sin tirantez', 'Respeta el pH cutáneo', 'Elimina polución urbana', 'Espuma ultra cremosa'],
    howToUse: 'Dispensar 1-2 pulsaciones sobre manos húmedas, masajear el rostro y aclarar.',
    keyIngredients: [
      { name: 'Hidrolato de Rosa Damascena', desc: 'Tonifica, calma y suaviza la piel durante el lavado.' },
      { name: 'Extracto de Pepino', desc: 'Aporta frescura, hidrata y descongestiona la tez.' },
      { name: 'Tensioactivos Suaves de Coco', desc: 'Agentes limpiadores biodegradables que no resecan.' }
    ]
  },
  'lip-mask': {
    id: 'lip-mask',
    wc_id: 407,
    name: 'Lip Sleeping Mask',
    subtitle: 'Manteca de Karité, Péptidos & Frutos Rojos',
    price: 22.00,
    volume: '15 ml',
    get image() { return camoGetAssetUrl('product_lip_mask.png'); },
    category: 'Bálsamo Labial Reparador Nocturno',
    rating: 4.97,
    reviewCount: 110,
    shortDesc: 'Tratamiento labial intensivo que repara grietas y nutre en profundidad mientras duermes.',
    fullDesc: 'Mascarilla labial de textura fundente rica en manteca de karité, cera botánica y péptidos redensificantes. Crea una película protectora que retiene la humedad toda la noche.',
    benefits: ['Repara labios agrietados en 1 noche', 'Efecto volumen y suavidad', 'Sabor natural a frutos del bosque', 'Acabado brillo no pegajoso'],
    howToUse: 'Aplicar una capa generosa sobre los labios antes de acostarse.',
    keyIngredients: [
      { name: 'Manteca de Karité Pura', desc: 'Nutre intensamente y regenera la piel agrietada.' },
      { name: 'Péptidos Voluminizadores', desc: 'Estimulan la producción de colágeno en la zona peribucal.' },
      { name: 'Extracto de Frutos Rojos', desc: 'Antioxidantes que protegen y aportan un aroma 100% natural.' }
    ]
  }
};

// ==========================================================================
// CART STATE & CORE ENGINE
// ==========================================================================
let CAMO_LIVE_CART = {
  item_count: 0,
  subtotal_html: '0,00 €',
  items: []
};

let CAMO_WISHLIST = [];
try {
  const savedW = localStorage.getItem('camo_wishlist_v1');
  if (savedW) CAMO_WISHLIST = JSON.parse(savedW);
} catch (e) {
  CAMO_WISHLIST = [];
}

try {
  const savedCart = localStorage.getItem('CAMO_LOCAL_CART_V2');
  if (savedCart) {
    CAMO_LIVE_CART = JSON.parse(savedCart);
  }
} catch (e) {
  CAMO_LIVE_CART = { item_count: 0, subtotal_html: '0,00 €', items: [] };
}

// ==========================================================================
// ZERO-LATENCY INSTANT CART & SYNC ENGINE (SHOPIFY + WC + STANDALONE)
// ==========================================================================

function camoFormatMoney(centsOrEuros) {
  let val = typeof centsOrEuros === 'number' ? centsOrEuros : parseFloat(centsOrEuros);
  if (isNaN(val)) val = 0;
  if (val >= 500 && Number.isInteger(val)) {
    val = val / 100;
  }
  return val.toFixed(2).replace('.', ',') + ' €';
}

function camoShowToast(message) {
  const toast = document.getElementById('toastMessage') || document.querySelector('.toast-message') || document.querySelector('.toast-notification');
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add('is-visible');
  setTimeout(() => toast.classList.remove('is-visible'), 3200);
}

function camoOpenCartDrawer() {
  const backdrop = document.getElementById('cartDrawerBackdrop') || document.querySelector('.cart-drawer-backdrop') || document.querySelector('.drawer-backdrop');
  if (backdrop) {
    backdrop.style.setProperty('display', 'flex', 'important');
    backdrop.style.setProperty('visibility', 'visible', 'important');
    backdrop.style.setProperty('opacity', '1', 'important');
    backdrop.style.setProperty('pointer-events', 'auto', 'important');
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  const drawer = document.getElementById('cartDrawer') || (backdrop ? backdrop.querySelector('.cart-drawer') : null);
  if (drawer) {
    drawer.style.setProperty('transform', 'translateX(0)', 'important');
  }
  camoRenderCart();
}

function camoCloseCartDrawer() {
  const backdrop = document.getElementById('cartDrawerBackdrop') || document.querySelector('.cart-drawer-backdrop') || document.querySelector('.drawer-backdrop');
  const drawer = document.getElementById('cartDrawer') || (backdrop ? backdrop.querySelector('.cart-drawer') : null);
  if (drawer) {
    drawer.style.setProperty('transform', 'translateX(100%)', 'important');
  }
  if (backdrop) {
    backdrop.classList.remove('is-open');
    backdrop.style.setProperty('opacity', '0', 'important');
    backdrop.style.setProperty('visibility', 'hidden', 'important');
    backdrop.style.setProperty('pointer-events', 'none', 'important');
    setTimeout(() => {
      if (!backdrop.classList.contains('is-open')) {
        backdrop.style.setProperty('display', 'none', 'important');
      }
    }, 350);
    document.body.style.overflow = '';
  }
}

function camoOpenWishlistDrawer() {
  const backdrop = document.getElementById('wishlistDrawerBackdrop') || document.querySelector('.wishlist-drawer-backdrop');
  if (backdrop) {
    backdrop.style.setProperty('display', 'flex', 'important');
    backdrop.style.setProperty('visibility', 'visible', 'important');
    backdrop.style.setProperty('opacity', '1', 'important');
    backdrop.style.setProperty('pointer-events', 'auto', 'important');
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  camoRenderWishlist();
}

function camoCloseWishlistDrawer() {
  const backdrop = document.getElementById('wishlistDrawerBackdrop') || document.querySelector('.wishlist-drawer-backdrop');
  if (backdrop) {
    backdrop.classList.remove('is-open');
    backdrop.style.setProperty('opacity', '0', 'important');
    backdrop.style.setProperty('visibility', 'hidden', 'important');
    backdrop.style.setProperty('pointer-events', 'none', 'important');
    setTimeout(() => {
      if (!backdrop.classList.contains('is-open')) {
        backdrop.style.setProperty('display', 'none', 'important');
      }
    }, 350);
    document.body.style.overflow = '';
  }
}


// Exact Live Shopify Catalog & Handle Map for camocosmetics.es
const CAMO_HANDLE_MAP = {
  'camo-calm-mist': [
    'bruma-facial-prebioticos-calm',
    'camo-calm-barrier-defense-mist',
    'camo-calm-mist',
    'barrier-defense-mist'
  ],
  'camo_calm_mist': [
    'bruma-facial-prebioticos-calm',
    'camo-calm-barrier-defense-mist',
    'camo-calm-mist'
  ],
  'bruma-facial-prebioticos-calm': [
    'bruma-facial-prebioticos-calm'
  ],
  'barrier-defense-mist': [
    'bruma-facial-prebioticos-calm'
  ],
  
  'camo-calm-serum': [
    'bioactive-prebiotics-jelly-serum',
    'camo-calm-serum',
    'camo-calm-prebiotics-serum',
    'bioactive-prebiotics-serum',
    'jelly-serum'
  ],
  'camo_calm_serum': [
    'bioactive-prebiotics-jelly-serum',
    'camo-calm-serum'
  ],
  'bioactive-prebiotics-jelly-serum': [
    'bioactive-prebiotics-jelly-serum'
  ],
  
  'niacinamide': [
    'niacinamide-gel-moisturiser-vitamina-b3-y-extracto-de-ginkgo-50ml',
    'niacinamide-gel-moisturiser',
    'niacinamide',
    'camo-hydra-cream'
  ],
  'niacinamide_gel_moisturiser': [
    'niacinamide-gel-moisturiser-vitamina-b3-y-extracto-de-ginkgo-50ml',
    'niacinamide-gel-moisturiser',
    'niacinamide'
  ],
  'niacinamide-gel-moisturiser': [
    'niacinamide-gel-moisturiser-vitamina-b3-y-extracto-de-ginkgo-50ml',
    'niacinamide-gel-moisturiser',
    'niacinamide'
  ],
  'niacinamide-gel-moisturiser-vitamina-b3-y-extracto-de-ginkgo-50ml': [
    'niacinamide-gel-moisturiser-vitamina-b3-y-extracto-de-ginkgo-50ml'
  ],
  'camo-hydra-cream': [
    'niacinamide-gel-moisturiser-vitamina-b3-y-extracto-de-ginkgo-50ml',
    'niacinamide'
  ],
  
  'reti-glow': [
    'reti-glow-serum-oil-bakuchiol-aceites-naturales-de-frambuesa-y-arandanos',
    'reti-glow-serum-oil',
    'reti-glow'
  ],
  'reti_glow': [
    'reti-glow-serum-oil-bakuchiol-aceites-naturales-de-frambuesa-y-arandanos',
    'reti-glow-serum-oil',
    'reti-glow'
  ],
  'reti-glow-serum-oil': [
    'reti-glow-serum-oil-bakuchiol-aceites-naturales-de-frambuesa-y-arandanos',
    'reti-glow-serum-oil',
    'reti-glow'
  ],
  'reti-glow-serum-oil-bakuchiol-aceites-naturales-de-frambuesa-y-arandanos': [
    'reti-glow-serum-oil-bakuchiol-aceites-naturales-de-frambuesa-y-arandanos'
  ],
  
  'purifying-mousse': [
    'purifying-mousse-grapefruit-and-lemon',
    'purifying-mousse-cleanser',
    'purifying-mousse'
  ],
  'purifying_mousse': [
    'purifying-mousse-grapefruit-and-lemon',
    'purifying-mousse'
  ],
  'purifying-mousse-cleanser': [
    'purifying-mousse-grapefruit-and-lemon',
    'purifying-mousse'
  ],
  'purifying-mousse-grapefruit-and-lemon': [
    'purifying-mousse-grapefruit-and-lemon'
  ],
  
  'lip-mask': [
    'lip-sleeping-mask-18gr',
    'lip-treatment-mask',
    'lip-mask'
  ],
  'lip_mask': [
    'lip-sleeping-mask-18gr',
    'lip-mask'
  ],
  'lip-treatment-mask': [
    'lip-sleeping-mask-18gr',
    'lip-mask'
  ],
  'lip-sleeping-mask-18gr': [
    'lip-sleeping-mask-18gr'
  ],
  
  'ceramide-cream': [
    'ceramide-barrier-night-cream'
  ],
  'ceramide-barrier-night-cream': [
    'ceramide-barrier-night-cream'
  ],
  
  'peptide-eye-cream': [
    'peptide-age-defying-eye-cream'
  ],
  'peptide-age-defying-eye-cream': [
    'peptide-age-defying-eye-cream'
  ],
  
  'peptide-cream': [
    'peptide-ageless-am-pm-cream'
  ],
  'peptide-ageless-am-pm-cream': [
    'peptide-ageless-am-pm-cream'
  ],
  
  'radiance-serum': [
    'pigment-perfecting-serum'
  ],
  'pigment-perfecting-serum': [
    'pigment-perfecting-serum'
  ],
  
  'the-ultimate-hydration-duo': [
    'the-ultimate-hydration-duo'
  ],
  'hydra-duo': [
    'the-ultimate-hydration-duo'
  ]
};

// Verified Live Shopify Variant IDs for camocosmetics.es
window.__camoShopifyVariantCache = Object.assign({
  // 1. CAMO CALM Mist (100ml)
  'bruma-facial-prebioticos-calm': 54630657720658,
  'camo-calm-mist': 54630657720658,
  'camo-calm-barrier-defense-mist': 54630657720658,
  '11123947110738': 54630657720658,
  
  // 2. Bioactive Prebiotics Jelly Serum (30ml)
  'bioactive-prebiotics-jelly-serum': 54626807447890,
  'camo-calm-serum': 54626807447890,
  'camo-calm-prebiotics-serum': 54626807447890,
  '11123449102674': 54626807447890,
  
  // 3. Niacinamide Gel Moisturiser (50ml)
  'niacinamide-gel-moisturiser-vitamina-b3-y-extracto-de-ginkgo-50ml': 54638984954194,
  'niacinamide-gel-moisturiser': 54638984954194,
  'niacinamide': 54638984954194,
  'camo-hydra-cream': 54638984954194,
  '11125101298002': 54638984954194,
  
  // 4. Reti-Glow Serum Oil
  'reti-glow-serum-oil-bakuchiol-aceites-naturales-de-frambuesa-y-arandanos': 54638986559826,
  'reti-glow-serum-oil': 54638986559826,
  'reti-glow': 54638986559826,
  '11125102346578': 54638986559826,
  
  // 5. Purifying Mousse
  'purifying-mousse-grapefruit-and-lemon': 54638978564434,
  'purifying-mousse-cleanser': 54638978564434,
  'purifying-mousse': 54638978564434,
  '11125100020050': 54638978564434,
  
  // 6. Lip Sleeping Mask
  'lip-sleeping-mask-18gr': 54638967062866,
  'lip-treatment-mask': 54638967062866,
  'lip-mask': 54638967062866,
  '11125098479954': 54638967062866,
  
  // 7. Ceramide Cream
  'ceramide-barrier-night-cream': 54631246594386,
  'ceramide-cream': 54631246594386,
  '11124030538066': 54631246594386,
  
  // 8. Peptide Eye Cream
  'peptide-age-defying-eye-cream': 54631317995858,
  'peptide-eye-cream': 54631317995858,
  '11124039188818': 54631317995858,
  
  // 9. Peptide AM/PM Cream
  'peptide-ageless-am-pm-cream': 54631298761042,
  'peptide-cream': 54631298761042,
  '11124037189970': 54631298761042,
  
  // 10. Radiance Renewal Serum
  'pigment-perfecting-serum': 54631280083282,
  'radiance-serum': 54631280083282,
  '11124034437458': 54631280083282,
  
  // 11. Ultimate Duo Pack
  'the-ultimate-hydration-duo': 54624106774866,
  'hydra-duo': 54624106774866,
  '11123166904658': 54624106774866
}, window.__camoShopifyVariantCache || {});

// Preload Shopify variant IDs in the background on page load
async function camoPreloadShopifyVariants() {
  const rootPath = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  try {
    const res = await fetch(rootPath + 'products.json?limit=50', { headers: { 'Accept': 'application/json' } });
    if (res.ok) {
      const data = await res.json();
      if (data && Array.isArray(data.products)) {
        data.products.forEach(p => {
          if (p.variants && p.variants.length > 0) {
            const vId = p.variants[0].id;
            if (p.handle) window.__camoShopifyVariantCache[p.handle] = vId;
            if (p.id) window.__camoShopifyVariantCache[String(p.id)] = vId;
            if (p.title) {
              const normTitle = p.title.toLowerCase().replace(/[^a-z0-9]/g, '');
              window.__camoShopifyVariantCache[normTitle] = vId;
            }
          }
        });
      }
    }
  } catch (e) {}
}

// Safely resolve the exact Shopify Variant ID for a specific product
async function camoGetShopifyVariantId(productIdentifier, handle, title, elemOrCard) {
  // 1. If productIdentifier is directly a numeric Shopify variant ID (>= 8 digits)
  if (typeof productIdentifier === 'number' && productIdentifier > 10000000) return productIdentifier;
  if (typeof productIdentifier === 'string' && /^\d{8,}$/.test(productIdentifier.trim())) {
    return parseInt(productIdentifier.trim(), 10);
  }

  // 2. Build list of potential handle candidates
  const candidates = [];
  if (handle) candidates.push(handle);
  const rawId = String(productIdentifier || '').trim();
  if (rawId) candidates.push(rawId);
  const normKey = rawId.toLowerCase().replace(/_/g, '-');
  if (normKey && !candidates.includes(normKey)) candidates.push(normKey);

  const mapped = CAMO_HANDLE_MAP[rawId] || CAMO_HANDLE_MAP[normKey];
  if (mapped && Array.isArray(mapped)) {
    mapped.forEach(h => { if (!candidates.includes(h)) candidates.push(h); });
  }

  // 3. Check memory cache (contains preloaded live store IDs)
  for (let c of candidates) {
    if (window.__camoShopifyVariantCache[c]) return window.__camoShopifyVariantCache[c];
  }
  if (title) {
    const normT = title.toLowerCase().replace(/[^a-z0-9]/g, '');
    if (window.__camoShopifyVariantCache[normT]) return window.__camoShopifyVariantCache[normT];
  }

  // 4. Check DOM for matching card/element ONLY
  if (elemOrCard && elemOrCard.getAttribute) {
    const directVid = elemOrCard.getAttribute('data-variant-id');
    if (directVid && /^\d{8,}$/.test(String(directVid).trim())) {
      const parsed = parseInt(String(directVid).trim(), 10);
      if (handle) window.__camoShopifyVariantCache[handle] = parsed;
      return parsed;
    }
  }

  for (let c of candidates) {
    const domCard = document.querySelector(`[data-product-handle="${c}"], [data-handle="${c}"], [data-product-id="${c}"], [data-slug="${c}"]`);
    if (domCard) {
      const vId = domCard.getAttribute('data-variant-id') || 
                  (domCard.querySelector('input[name="id"]') ? domCard.querySelector('input[name="id"]').value : null);
      if (vId && /^\d{8,}$/.test(String(vId).trim())) {
        const parsed = parseInt(String(vId).trim(), 10);
        window.__camoShopifyVariantCache[c] = parsed;
        return parsed;
      }
    }
  }

  // 5. If we are on the single product page of THIS specific product
  if (typeof window !== 'undefined' && window.location && window.location.pathname.includes('/products/')) {
    const currentUrlHandle = window.location.pathname.split('/products/')[1]?.split('?')[0]?.replace(/\/$/, '');
    if (currentUrlHandle && candidates.includes(currentUrlHandle)) {
      const singleFormInput = document.querySelector('form[action*="/cart/add"] input[name="id"], #camoProductForm input[name="id"]');
      if (singleFormInput && singleFormInput.value && /^\d{8,}$/.test(singleFormInput.value.trim())) {
        const parsed = parseInt(singleFormInput.value.trim(), 10);
        window.__camoShopifyVariantCache[currentUrlHandle] = parsed;
        return parsed;
      }
    }
  }

  // 6. Asynchronous fetch to Shopify's /products/${candidate}.js
  const rootPath = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  for (let c of candidates) {
    try {
      const res = await fetch(rootPath + 'products/' + encodeURIComponent(c) + '.js', {
        headers: { 'Accept': 'application/json' }
      });
      if (res.ok) {
        const data = await res.json();
        if (data && data.variants && data.variants.length > 0) {
          const vId = data.variants[0].id;
          window.__camoShopifyVariantCache[c] = vId;
          if (data.handle) window.__camoShopifyVariantCache[data.handle] = vId;
          return vId;
        }
      }
    } catch (e) {}
  }

  // 7. Search API fallback
  if (title || rawId) {
    try {
      const query = encodeURIComponent(title || rawId);
      const sRes = await fetch(rootPath + 'search/suggest.json?q=' + query + '&resources[type]=product&resources[options][fields]=title,handle', {
        headers: { 'Accept': 'application/json' }
      });
      if (sRes.ok) {
        const sData = await sRes.json();
        const prods = sData?.resources?.results?.products;
        if (prods && prods.length > 0 && prods[0].handle) {
          const pRes = await fetch(rootPath + 'products/' + prods[0].handle + '.js');
          if (pRes.ok) {
            const pData = await pRes.json();
            if (pData?.variants?.[0]?.id) {
              const vId = pData.variants[0].id;
              window.__camoShopifyVariantCache[prods[0].handle] = vId;
              return vId;
            }
          }
        }
      }
    } catch (e) {}
  }

  return null;
}

// 1. Fetch Cart (WooCommerce / Shopify / LocalStorage)
async function camoFetchLiveCart(openDrawerAfter = false) {
  // A. Check WordPress / WooCommerce
  if (typeof window !== 'undefined' && window.CAMO_WP && window.CAMO_WP.ajax_url) {
    try {
      const formData = new FormData();
      formData.append('action', 'camo_get_cart_data');
      if (window.CAMO_WP.nonce) formData.append('nonce', window.CAMO_WP.nonce);
      const wpRes = await fetch(window.CAMO_WP.ajax_url, { method: 'POST', body: formData });
      const wpData = await wpRes.json();
      if (wpData && wpData.success && wpData.data) {
        CAMO_LIVE_CART = wpData.data;
        camoRenderCart();
        if (openDrawerAfter) camoOpenCartDrawer();
        return;
      }
    } catch (e) {}
  }

  // B. Check Shopify AJAX API
  const rootPath = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  try {
    const res = await fetch(rootPath + 'cart.js', { headers: { 'Accept': 'application/json' } });
    if (res.ok) {
      const data = await res.json();
      if (data && typeof data.item_count === 'number') {
        const mappedItems = (data.items || []).map(item => ({
          key: String(item.key || item.id),
          id: item.id,
          handle: item.handle || '',
          name: item.product_title || item.title,
          variant_title: item.variant_title || '',
          price: item.price ? item.price / 100 : 0,
          price_html: camoFormatMoney(item.line_price),
          unit_price_html: camoFormatMoney(item.price),
          quantity: item.quantity,
          image: item.image || (item.featured_image ? (typeof item.featured_image === 'string' ? item.featured_image : item.featured_image.url) : camoGetAssetUrl('product_reti_glow.png')),
          url: item.url || '#'
        }));

        if (mappedItems.length > 0) {
          const prevCart = CAMO_LIVE_CART || {};
          const isRitual = prevCart.is_ritual_applied || (mappedItems.length >= 3);
          CAMO_LIVE_CART = {
            item_count: data.item_count || 0,
            subtotal_html: camoFormatMoney(data.total_price),
            items: mappedItems,
            is_ritual_applied: isRitual,
            discount_code: prevCart.discount_code || (isRitual ? 'RITUAL15' : ''),
            discount_percent: prevCart.discount_percent || 15
          };
        } else {
          try {
            const saved = localStorage.getItem('CAMO_LOCAL_CART_V2');
            if (saved) {
              const parsed = JSON.parse(saved);
              if (parsed && parsed.items && parsed.items.length > 0) {
                CAMO_LIVE_CART = parsed;
              }
            }
          } catch (e) {}
        }

        camoRenderCart();
        if (openDrawerAfter) camoOpenCartDrawer();
        return;
      }
    }
  } catch (err) {}

  // C. Fallback: LocalStorage Cart
  try {
    const saved = localStorage.getItem('CAMO_LOCAL_CART_V2');
    if (saved) {
      CAMO_LIVE_CART = JSON.parse(saved);
    }
  } catch (e) {}

  camoRenderCart();
  if (openDrawerAfter) camoOpenCartDrawer();
}

// 2. Add To Cart (Instant Reactive Update + Asynchronous Backend Sync)
async function camoAddToCart(productIdentifier, quantity = 1, showDrawer = true, extraMeta = {}) {
  quantity = parseInt(quantity) || 1;
  if (quantity < 1) quantity = 1;

  let elem = null;
  let card = null;

  // 1. Resolve DOM Element & Dataset Attributes
  if (productIdentifier && (productIdentifier instanceof HTMLElement || productIdentifier.nodeType === 1)) {
    elem = productIdentifier;
    card = elem.closest('.product-card, .camo-single-product-wrapper, .camo-grid-product-card, .product-item, [data-variant-id], [data-product-id], [data-product-handle]') || elem.closest('form, article, li, div') || elem;
    
    const vId = (elem && (elem.getAttribute('data-variant-id') || elem.getAttribute('data-product-id') || elem.getAttribute('data-product_id') || elem.getAttribute('data-id'))) ||
                (card && (card.getAttribute('data-variant-id') || card.getAttribute('data-product-id') || card.getAttribute('data-product_id') || card.getAttribute('data-id')));
                
    const hnd = (elem && (elem.getAttribute('data-product-handle') || elem.getAttribute('data-handle') || elem.getAttribute('data-slug'))) ||
                (card && (card.getAttribute('data-product-handle') || card.getAttribute('data-handle') || card.getAttribute('data-slug'))) ||
                (card && card.querySelector('a[href*="/products/"]') ? card.querySelector('a[href*="/products/"]').getAttribute('href').split('/products/')[1]?.split('?')[0] : null);
                
    const tit = (elem && (elem.getAttribute('data-product-title') || elem.getAttribute('data-title'))) ||
                (card && (card.getAttribute('data-product-title') || card.getAttribute('data-title'))) ||
                (card && card.querySelector('.product-name, .camo-card-title, h1, h2, h3') ? card.querySelector('.product-name, .camo-card-title, h1, h2, h3').textContent.trim() : null) ||
                (document.querySelector('.product-title, h1.product-name, .camo-product-sticky-info h1') ? document.querySelector('.product-title, h1.product-name, .camo-product-sticky-info h1').textContent.trim() : null);
                
    const prc = (elem && (elem.getAttribute('data-product-price') || elem.getAttribute('data-price'))) ||
                (card && (card.getAttribute('data-product-price') || card.getAttribute('data-price'))) ||
                (card && card.querySelector('.product-price, .camo-card-price, .price') ? card.querySelector('.product-price, .camo-card-price, .price').textContent.trim() : null);
                
    const img = (elem && (elem.getAttribute('data-product-image') || elem.getAttribute('data-image'))) ||
                (card && (card.getAttribute('data-product-image') || card.getAttribute('data-image'))) ||
                (card && card.querySelector('.product-image, img') ? card.querySelector('.product-image, img').src : null);

    const resolvedUrl = (card && card.querySelector('a[href*="/products/"]') ? card.querySelector('a[href*="/products/"]').getAttribute('href') : null) || (hnd ? ('/products/' + hnd) : null);
                
    productIdentifier = vId || hnd || '';
    extraMeta = { title: tit, price: prc, image: img, handle: hnd, variantId: vId, url: resolvedUrl };
  } else if (productIdentifier && typeof productIdentifier === 'object') {
    if (!extraMeta || Object.keys(extraMeta).length === 0) {
      extraMeta = productIdentifier;
    }
    productIdentifier = productIdentifier.variantId || productIdentifier.variant_id || productIdentifier.id || productIdentifier.handle || productIdentifier.slug || '';
  }

  const rawIdStr = String(productIdentifier || '').trim();
  const normalizedKey = rawIdStr.toLowerCase().replace(/_/g, '-');
  let localProduct = null;
  const isWooCommerce = (typeof window !== 'undefined' && window.CAMO_WP && window.CAMO_WP.ajax_url);
  const isShopify = (typeof window !== 'undefined' && (window.Shopify || (window.location && window.location.pathname && (window.location.pathname.includes('/products/') || window.location.pathname.includes('/collections/'))) || (window.location && window.location.hostname && window.location.hostname.includes('myshopify.com'))));

  // Comprehensive Product Aliases Map
  const ID_ALIASES = {
    'camo_calm_mist': 'camo-calm-mist',
    'camo-calm-mist': 'camo-calm-mist',
    'camo-calm-barrier-defense-mist': 'camo-calm-mist',
    'barrier-defense-mist': 'camo-calm-mist',
    'mist': 'camo-calm-mist',
    
    'camo_calm_serum': 'camo-calm-serum',
    'camo-calm-serum': 'camo-calm-serum',
    'bioactive-prebiotics-jelly-serum': 'camo-calm-serum',
    'bioactive_prebiotics_jelly_serum': 'camo-calm-serum',
    'jelly-serum': 'camo-calm-serum',
    'camo-calm-prebiotics-serum': 'camo-calm-serum',
    
    'niacinamide': 'niacinamide',
    'niacinamide-gel-moisturiser': 'niacinamide',
    'niacinamide_gel_moisturiser': 'niacinamide',
    'camo_hydra_cream': 'niacinamide',
    'camo-hydra-cream': 'niacinamide',
    'gel-moisturiser': 'niacinamide',
    
    'reti-glow': 'reti-glow',
    'reti_glow': 'reti-glow',
    'reti-glow-serum-oil': 'reti-glow',
    'camo_renew_elixir': 'reti-glow',
    'camo-renew-elixir': 'reti-glow',
    'bakuchiol': 'reti-glow',

    'peeling-enzimatico': 'peeling-enzimatico',
    'peeling_enzimatico': 'peeling-enzimatico',
    'purifying-mousse': 'purifying-mousse',
    'purifying_mousse': 'purifying-mousse',
    'lip-mask': 'lip-mask',
    'lip_mask': 'lip-mask'
  };

  const resolvedAlias = ID_ALIASES[rawIdStr] || ID_ALIASES[normalizedKey];

  // Look up product in catalog
  if (resolvedAlias && CAMO_PRODUCTS[resolvedAlias]) {
    localProduct = CAMO_PRODUCTS[resolvedAlias];
  } else if (CAMO_PRODUCTS[rawIdStr]) {
    localProduct = CAMO_PRODUCTS[rawIdStr];
  } else if (CAMO_PRODUCTS[normalizedKey]) {
    localProduct = CAMO_PRODUCTS[normalizedKey];
  } else {
    for (let k in CAMO_PRODUCTS) {
      const p = CAMO_PRODUCTS[k];
      if (p.id === rawIdStr || 
          p.id === normalizedKey ||
          (p.slug && (p.slug === rawIdStr || p.slug === normalizedKey)) ||
          String(p.wc_id) === rawIdStr || 
          (p.name && p.name.toLowerCase() === rawIdStr.toLowerCase()) ||
          normalizedKey.includes(k) ||
          k.includes(normalizedKey)) {
        localProduct = p;
        break;
      }
    }
  }

  // Determine Product Display Info
  let itemTitle = (extraMeta && extraMeta.title) || (localProduct && localProduct.name);
  let itemPrice = (extraMeta && typeof extraMeta.price === 'number' ? extraMeta.price : null) || (localProduct && localProduct.price);
  let itemImage = (extraMeta && extraMeta.image) || (localProduct && localProduct.image);

  if (!itemTitle) {
    const pageTitle = (card ? card.querySelector('.product-name, h1, h2, h3, .camo-card-title') : null) || document.querySelector('.camo-product-sticky-info h1, .product-title, h1.product-name');
    if (pageTitle) itemTitle = pageTitle.textContent.trim();
  }
  if (!itemTitle) itemTitle = (localProduct && localProduct.name) || 'Tratamiento Botánico CAMO';

  if (!itemPrice) {
    const pagePrice = (extraMeta && extraMeta.price) || (card ? card.querySelector('.product-price, .camo-card-price, .price') : null) || document.querySelector('.camo-product-sticky-info .product-price, .product-price');
    if (pagePrice) {
      const strP = typeof pagePrice === 'string' ? pagePrice : (pagePrice.textContent || '30');
      itemPrice = parseFloat(strP.replace(',', '.').replace(/[^0-9.]/g, '')) || 30.00;
    } else {
      itemPrice = 30.00;
    }
  }

  if (!itemImage) {
    const pageImg = (card ? card.querySelector('.product-image, img, .camo-vertical-img') : null) || document.querySelector('.camo-vertical-img, .product-image');
    itemImage = pageImg ? pageImg.src : (localProduct && localProduct.image) || camoGetAssetUrl('product_camo_calm_serum.png');
  }

  // =========================================================================
  // STEP 1: INSTANT REACTIVE CLIENT-SIDE UPDATE (0ms LATENCY GUARANTEED)
  // =========================================================================
  if (!CAMO_LIVE_CART.items) CAMO_LIVE_CART.items = [];

  const itemId = (extraMeta && (extraMeta.variantId || extraMeta.id)) || (localProduct && localProduct.id) || resolvedAlias || rawIdStr || ('prod-' + Date.now());
  const existing = CAMO_LIVE_CART.items.find(i => String(i.id) === String(itemId) || String(i.key) === String(itemId) || (itemTitle && i.name && i.name.toLowerCase() === itemTitle.toLowerCase()));
  
  if (existing) {
    existing.quantity += quantity;
    const unitP = typeof existing.price === 'number' ? existing.price : itemPrice;
    existing.price_html = camoFormatMoney(existing.quantity * unitP);
  } else {
    const resolvedItemUrl = (extraMeta && extraMeta.url) || 
                            (localProduct && ('/products/' + (localProduct.slug || localProduct.id))) ||
                            (typeof window !== 'undefined' && window.location.pathname.includes('/products/') ? window.location.pathname : null) ||
                            (extraMeta && extraMeta.handle ? ('/products/' + extraMeta.handle) : '/collections/all');

    CAMO_LIVE_CART.items.push({
      key: String(itemId),
      id: itemId,
      name: itemTitle,
      price: itemPrice,
      unit_price_html: camoFormatMoney(itemPrice),
      price_html: camoFormatMoney(itemPrice * quantity),
      quantity: quantity,
      image: itemImage,
      url: resolvedItemUrl,
      handle: (extraMeta && extraMeta.handle) || (localProduct && localProduct.slug) || ''
    });
  }

  // Recalculate Totals
  let totalCount = 0;
  let totalPrice = 0;
  CAMO_LIVE_CART.items.forEach(it => {
    totalCount += it.quantity;
    const p = typeof it.price === 'number' ? it.price : (parseFloat(String(it.unit_price_html || it.price_html || '').replace(',', '.').replace(/[^0-9.]/g, '')) || itemPrice);
    totalPrice += p * it.quantity;
  });

  CAMO_LIVE_CART.item_count = totalCount;
  CAMO_LIVE_CART.subtotal_html = camoFormatMoney(totalPrice);

  try {
    localStorage.setItem('CAMO_LOCAL_CART_V2', JSON.stringify(CAMO_LIVE_CART));
  } catch (e) {}

  // RENDER & OPEN IMMEDIATELY
  camoRenderCart();
  camoShowToast('✓ Producto añadido a tu cesta');
  if (showDrawer) {
    camoOpenCartDrawer();
  }

  // =========================================================================
  // STEP 2: ASYNCHRONOUS BACKEND SYNC (SHOPIFY / WOOCOMMERCE)
  // =========================================================================
  
  // A. SHOPIFY BACKEND SYNC
  if (isShopify) {
    const handle = (extraMeta && extraMeta.handle) || (localProduct && localProduct.slug) || rawIdStr;
    const shopifyVariantId = await camoGetShopifyVariantId(productIdentifier, handle, itemTitle, elem || card);

    if (shopifyVariantId && shopifyVariantId > 0) {
      const rootPath = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      
      try {
        const sRes = await fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: shopifyVariantId,
              quantity: quantity
            }]
          })
        });
        if (sRes.ok) {
          fetch(rootPath + 'cart.js', { headers: { 'Accept': 'application/json' } })
            .then(r => r.json())
            .then(data => {
              if (data && data.items && data.items.length > 0) {
                CAMO_LIVE_CART = {
                  item_count: data.item_count,
                  subtotal_html: camoFormatMoney(data.total_price),
                  items: data.items.map(item => ({
                    key: String(item.key || item.id),
                    id: item.id,
                    name: item.product_title || item.title,
                    price: item.price ? item.price / 100 : 0,
                    price_html: camoFormatMoney(item.line_price),
                    unit_price_html: camoFormatMoney(item.price),
                    quantity: item.quantity,
                    image: item.image || camoGetAssetUrl('product_camo_calm_serum.png'),
                    url: item.url || '#'
                  }))
                };
                camoRenderCart();
              }
            }).catch(() => {});
        }
      } catch (e) {}
    }
  }

  // B. WOOCOMMERCE BACKEND SYNC
  if (isWooCommerce) {
    let wcId = (localProduct && localProduct.wc_id) || (!isNaN(parseInt(rawIdStr)) ? parseInt(rawIdStr) : 0);
    if (wcId > 0) {
      try {
        const formData = new FormData();
        formData.append('action', 'camo_add_to_cart');
        formData.append('product_id', wcId);
        formData.append('quantity', quantity);
        if (window.CAMO_WP.nonce) formData.append('nonce', window.CAMO_WP.nonce);
        fetch(window.CAMO_WP.ajax_url, { method: 'POST', body: formData });
      } catch (e) {}
    }
  }
}

// 3. Update Cart Quantity
async function camoUpdateCartItemQty(keyOrId, newQty) {
  newQty = parseInt(newQty) || 0;
  if (newQty <= 0) {
    return camoRemoveCartItem(keyOrId);
  }

  // Update in local cart immediately
  if (CAMO_LIVE_CART.items) {
    const it = CAMO_LIVE_CART.items.find(i => i.key == keyOrId || i.id == keyOrId);
    if (it) {
      it.quantity = newQty;
      const p = typeof it.price === 'number' ? it.price : 30;
      it.price_html = camoFormatMoney(p * newQty);
    }
    let totalCount = 0;
    let totalPrice = 0;
    CAMO_LIVE_CART.items.forEach(i => {
      totalCount += i.quantity;
      const p = typeof i.price === 'number' ? i.price : 30;
      totalPrice += p * i.quantity;
    });
    CAMO_LIVE_CART.item_count = totalCount;
    CAMO_LIVE_CART.subtotal_html = camoFormatMoney(totalPrice);
    try { localStorage.setItem('CAMO_LOCAL_CART_V2', JSON.stringify(CAMO_LIVE_CART)); } catch (e) {}
    camoRenderCart();
  }

  // Backend sync Shopify
  const rootPath = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  try {
    fetch(rootPath + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: String(keyOrId), quantity: newQty })
    });
  } catch (e) {}

  // Backend sync WordPress
  if (typeof window !== 'undefined' && window.CAMO_WP && window.CAMO_WP.ajax_url) {
    try {
      const formData = new FormData();
      formData.append('action', 'camo_update_cart_qty');
      formData.append('cart_item_key', keyOrId);
      formData.append('quantity', newQty);
      if (window.CAMO_WP.nonce) formData.append('nonce', window.CAMO_WP.nonce);
      fetch(window.CAMO_WP.ajax_url, { method: 'POST', body: formData });
    } catch (e) {}
  }
}

// 4. Remove Cart Item
async function camoRemoveCartItem(keyOrId) {
  if (CAMO_LIVE_CART.items) {
    CAMO_LIVE_CART.items = CAMO_LIVE_CART.items.filter(i => i.key != keyOrId && i.id != keyOrId);
    let totalCount = 0;
    let totalPrice = 0;
    CAMO_LIVE_CART.items.forEach(i => {
      totalCount += i.quantity;
      const p = typeof i.price === 'number' ? i.price : 30;
      totalPrice += p * i.quantity;
    });
    CAMO_LIVE_CART.item_count = totalCount;
    CAMO_LIVE_CART.subtotal_html = camoFormatMoney(totalPrice);
    try { localStorage.setItem('CAMO_LOCAL_CART_V2', JSON.stringify(CAMO_LIVE_CART)); } catch (e) {}
    camoRenderCart();
    camoShowToast('✓ Producto eliminado de la cesta');
  }

  // Backend sync Shopify
  const rootPath = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  try {
    fetch(rootPath + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: String(keyOrId), quantity: 0 })
    });
  } catch (e) {}

  // Backend sync WordPress
  if (typeof window !== 'undefined' && window.CAMO_WP && window.CAMO_WP.ajax_url) {
    try {
      const formData = new FormData();
      formData.append('action', 'camo_remove_cart_item');
      formData.append('cart_item_key', keyOrId);
      if (window.CAMO_WP.nonce) formData.append('nonce', window.CAMO_WP.nonce);
      fetch(window.CAMO_WP.ajax_url, { method: 'POST', body: formData });
    } catch (e) {}
  }
}

// 5. Render Cart Drawer
function camoRenderCart() {
  let rawTotal = 0;
  let totalCount = 0;
  if (CAMO_LIVE_CART.items && CAMO_LIVE_CART.items.length) {
    CAMO_LIVE_CART.items.forEach(it => {
      totalCount += (it.quantity || 1);
      let p = 30.00;
      if (typeof it.price === 'number') {
        p = it.price > 1000 ? (it.price / 100) : it.price;
      } else {
        const parsed = parseFloat(String(it.unit_price_html || it.price_html || '').replace(',', '.').replace(/[^0-9.]/g, ''));
        if (!isNaN(parsed) && parsed > 0) p = parsed;
      }
      rawTotal += p * (it.quantity || 1);
    });
  }
  CAMO_LIVE_CART.item_count = totalCount;

  // Determine if ritual discount applies (if ritual flag is set, code RITUALCAMO is applied, or 3+ products are in cart)
  const isRitual = !!(CAMO_LIVE_CART.is_ritual_applied || CAMO_LIVE_CART.discount_code === 'RITUALCAMO' || CAMO_LIVE_CART.discount_code === 'RITUAL15' || CAMO_LIVE_CART.discount_code === 'CAMO15' || (CAMO_LIVE_CART.items && CAMO_LIVE_CART.items.length >= 3 && CAMO_LIVE_CART.is_ritual_applied !== false));
  const discountPct = isRitual ? 15 : (CAMO_LIVE_CART.discount_code === 'CAMO10' || CAMO_LIVE_CART.discount_code === 'BIENVENIDA10' ? 10 : 0);
  const discountAmount = discountPct > 0 ? (rawTotal * (discountPct / 100)) : 0;
  const finalTotal = Math.max(0, rawTotal - discountAmount);

  CAMO_LIVE_CART.raw_total = rawTotal;
  CAMO_LIVE_CART.discount_amount = discountAmount;
  CAMO_LIVE_CART.final_total = finalTotal;
  CAMO_LIVE_CART.subtotal_html = camoFormatMoney(finalTotal);

  const countBadges = document.querySelectorAll('.cart-count-badge');
  countBadges.forEach(b => b.textContent = CAMO_LIVE_CART.item_count || 0);

  const countEls = document.querySelectorAll('#cartItemCount, .cart-item-count');
  countEls.forEach(el => el.textContent = `${CAMO_LIVE_CART.item_count || 0} producto${CAMO_LIVE_CART.item_count === 1 ? '' : 's'}`);

  // Display Discount Row in Cart Drawer
  const discountRows = document.querySelectorAll('#cartDiscountRow, .cart-discount-row');
  discountRows.forEach(row => {
    if (discountAmount > 0) {
      row.style.setProperty('display', 'flex', 'important');
      const labelEl = row.querySelector('.discount-label') || row.querySelector('span:first-child');
      if (labelEl) {
        labelEl.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block; vertical-align:middle; margin-right:4px;"><polyline points="20 6 9 17 4 12"></polyline></svg> ✓ ${isRitual ? '15% DTO en Ritual (Cupón RITUALCAMO)' : 'Descuento Aplicado'}:`;
      }
      const amountEl = row.querySelector('#cartDiscountAmount, .discount-amount') || row.querySelector('span:last-child');
      if (amountEl) {
        amountEl.textContent = `-${camoFormatMoney(discountAmount)}`;
      }
    } else {
      row.style.setProperty('display', 'none', 'important');
    }
  });

  // Display Subtotal / Final Total (with strikethrough original if discounted)
  const subtotalEls = document.querySelectorAll('#cartSubtotal, #cartTotal, .cart-subtotal-val');
  subtotalEls.forEach(el => {
    if (discountAmount > 0) {
      el.innerHTML = `<span style="text-decoration: line-through; color: #8A8284; font-size: 0.95rem; font-weight: 500; margin-right: 0.45rem;">${camoFormatMoney(rawTotal)}</span><span style="color: #1C1718; font-weight: 700;">${camoFormatMoney(finalTotal)}</span>`;
    } else {
      el.innerHTML = camoFormatMoney(rawTotal);
    }
  });

  // Update Checkout Links to pass discount to Shopify Checkout
  const checkoutBtns = document.querySelectorAll('#drawerCheckoutBtn, #checkoutBtn, .checkout-btn');
  checkoutBtns.forEach(btn => {
    if (btn.tagName === 'A') {
      if (isRitual) {
        btn.href = '/discount/RITUALCAMO?redirect=/checkout';
      } else if (CAMO_LIVE_CART.discount_code) {
        btn.href = `/discount/${CAMO_LIVE_CART.discount_code}?redirect=/checkout`;
      } else {
        btn.href = '/checkout';
      }
    }
  });

  const shippingText = document.getElementById('shippingMeterText');
  const shippingBar = document.getElementById('shippingProgressBar');
  if (shippingText || shippingBar) {
    const freeThreshold = 45.00;
    const pct = Math.min(100, Math.round((finalTotal / freeThreshold) * 100));
    if (shippingBar) shippingBar.style.width = pct + '%';
    if (shippingText) {
      if (finalTotal >= freeThreshold) {
        shippingText.innerHTML = '✨ ¡Felicidades! Tienes <strong>Envío Gratis</strong> garantizado';
      } else {
        const diff = (freeThreshold - finalTotal).toFixed(2).replace('.', ',');
        shippingText.innerHTML = `Añade <strong>${diff} €</strong> más para <strong>Envío Gratis</strong>`;
      }
    }
  }

  const containers = document.querySelectorAll('#cartItemsList, #cartDrawerItems, .cart-items-list');
  const emptyStates = document.querySelectorAll('#cartEmptyState, .cart-empty-state');

  if (!CAMO_LIVE_CART.items || CAMO_LIVE_CART.items.length === 0) {
    emptyStates.forEach(es => es.style.setProperty('display', 'block', 'important'));
    containers.forEach(c => c.innerHTML = '');
    return;
  }

  emptyStates.forEach(es => es.style.setProperty('display', 'none', 'important'));

  const itemsHtml = CAMO_LIVE_CART.items.map(item => {
    const itemLink = item.url && item.url !== '#' ? item.url : (item.handle ? ('/products/' + item.handle) : '/collections/all');
    return `
    <div class="cart-item" style="display:flex; align-items:center; gap:1.15rem; padding:1.1rem 0; border-bottom:1px solid rgba(28,23,24,0.06);">
      <a href="${itemLink}" onclick="window.camoApp.closeCart()" style="flex-shrink:0; display:block;" title="Ver ficha de producto">
        <img src="${item.image || camoGetAssetUrl('product_camo_calm_serum.png')}" alt="${item.name || 'Producto CAMO'}" class="cart-item-thumb" style="width:68px; height:68px; object-fit:contain; background:#FAF7F2; border-radius:12px; padding:0.35rem; border:1px solid rgba(28,23,24,0.05); display:block; cursor:pointer; transition:transform 0.2s;">
      </a>
      <div style="flex:1; min-width:0;">
        <a href="${itemLink}" onclick="window.camoApp.closeCart()" style="text-decoration:none; color:inherit; display:block;" title="Ver ficha de producto">
          <h4 class="cart-item-title" style="font-family:'Plus Jakarta Sans',sans-serif; font-size:0.92rem; font-weight:700; color:#1C1718; margin:0 0 0.2rem; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; cursor:pointer;">
            ${item.name || 'Producto CAMO'}
          </h4>
        </a>
        <div style="font-size:0.85rem; font-weight:700; color:#C67A63; margin-bottom:0.5rem;">
          ${item.price_html || item.unit_price_html || camoFormatMoney(item.price || 30)}
        </div>
        <div style="display:flex; align-items:center; gap:0.6rem;">
          <div style="display:inline-flex; align-items:center; border:1px solid rgba(28,23,24,0.12); border-radius:50px; background:#FFF;">
            <button type="button" onclick="window.camoApp.updateLiveQty('${item.key || item.id}', ${item.quantity - 1})" style="border:none; background:none; width:26px; height:26px; cursor:pointer; font-weight:700; font-size:0.85rem; color:#1C1718;" aria-label="Restar">-</button>
            <span style="font-size:0.8rem; font-weight:700; min-width:18px; text-align:center;">${item.quantity}</span>
            <button type="button" onclick="window.camoApp.updateLiveQty('${item.key || item.id}', ${item.quantity + 1})" style="border:none; background:none; width:26px; height:26px; cursor:pointer; font-weight:700; font-size:0.85rem; color:#1C1718;" aria-label="Sumar">+</button>
          </div>
          <button type="button" onclick="window.camoApp.removeLiveItem('${item.key || item.id}')" style="border:none; background:none; color:#A09899; font-size:0.75rem; text-decoration:underline; cursor:pointer; padding:0.2rem;">
            Eliminar
          </button>
        </div>
      </div>
    </div>
  `; }).join('');

  containers.forEach(c => c.innerHTML = itemsHtml);
}

// 6. Routine Builder Complete Add (Batch add all selected distinct formulas)
async function camoAddBuiltRoutineToShopify() {
  const cards = document.querySelectorAll('.routine-product-card.is-selected');
  if (!cards.length) {
    camoShowToast('Selecciona al menos un tratamiento para tu ritual');
    return;
  }

  const selectedProducts = [];
  cards.forEach(card => {
    const pid = card.getAttribute('data-product-id') || 'camo-calm-serum';
    const handle = card.getAttribute('data-product-handle') || pid;
    const tit = card.querySelector('h4') ? card.querySelector('h4').textContent.trim() : (CAMO_PRODUCTS[pid]?.name || 'Fórmula Botánica CAMO');
    const prc = parseFloat(card.getAttribute('data-price')) || (CAMO_PRODUCTS[pid]?.price || 30.00);
    const imgEl = card.querySelector('img');
    const img = imgEl ? imgEl.src : (CAMO_PRODUCTS[pid]?.image || camoGetAssetUrl('product_camo_calm_serum.png'));
    const vid = card.getAttribute('data-variant-id');

    selectedProducts.push({
      id: pid,
      handle: handle,
      title: tit,
      price: prc,
      image: img,
      variantId: vid,
      url: '/products/' + handle
    });
  });

  // 1. Instant local cart update with all selected distinct products
  if (!CAMO_LIVE_CART.items) CAMO_LIVE_CART.items = [];
  
  selectedProducts.forEach(prod => {
    const existing = CAMO_LIVE_CART.items.find(i => 
      String(i.id) === String(prod.id) || 
      (prod.handle && i.handle === prod.handle) ||
      (prod.title && i.name && i.name.toLowerCase() === prod.title.toLowerCase())
    );
    if (existing) {
      existing.quantity += 1;
      const unitP = typeof existing.price === 'number' ? existing.price : prod.price;
      existing.price_html = camoFormatMoney(existing.quantity * unitP);
    } else {
      CAMO_LIVE_CART.items.push({
        key: String(prod.id),
        id: prod.id,
        name: prod.title,
        price: prod.price,
        unit_price_html: camoFormatMoney(prod.price),
        price_html: camoFormatMoney(prod.price),
        quantity: 1,
        image: prod.image,
        url: prod.url,
        handle: prod.handle
      });
    }
  });

  // Apply 15% discount when ritual is added
  CAMO_LIVE_CART.is_ritual_applied = true;
  CAMO_LIVE_CART.discount_code = 'RITUALCAMO';
  CAMO_LIVE_CART.discount_percent = 15;

  let totalCount = 0;
  let totalPrice = 0;
  CAMO_LIVE_CART.items.forEach(it => {
    totalCount += it.quantity;
    const p = typeof it.price === 'number' ? it.price : 30;
    totalPrice += p * it.quantity;
  });
  CAMO_LIVE_CART.item_count = totalCount;
  CAMO_LIVE_CART.subtotal_html = camoFormatMoney(totalPrice * 0.85);

  try { localStorage.setItem('CAMO_LOCAL_CART_V2', JSON.stringify(CAMO_LIVE_CART)); } catch (e) {}
  camoRenderCart();
  camoShowToast('✨ Ritual personalizado (' + selectedProducts.length + ' fórmulas) añadido a tu cesta (-15% DTO cupón RITUALCAMO)');
  camoOpenCartDrawer();

  // 2. Shopify Asynchronous Backend Batch Sync
  const isShopify = (typeof window !== 'undefined' && (window.Shopify || (window.location && window.location.pathname && (window.location.pathname.includes('/products/') || window.location.pathname.includes('/collections/'))) || (window.location && window.location.hostname && window.location.hostname.includes('myshopify.com'))));
  
  if (isShopify) {
    const rootPath = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    const itemsToAdd = [];

    for (let prod of selectedProducts) {
      const vId = await camoGetShopifyVariantId(prod.id, prod.handle, prod.title);
      if (vId) {
        itemsToAdd.push({ id: vId, quantity: 1 });
      }
    }

    if (itemsToAdd.length > 0) {
      try {
        const sRes = await fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        });
        if (sRes.ok) {
          const cRes = await fetch(rootPath + 'cart.js', { headers: { 'Accept': 'application/json' } });
          if (cRes.ok) {
            const data = await cRes.json();
            if (data && data.items && data.items.length > 0) {
              CAMO_LIVE_CART = {
                item_count: data.item_count,
                subtotal_html: camoFormatMoney(data.total_price),
                is_ritual_applied: true,
                discount_code: 'RITUALCAMO',
                discount_percent: 15,
                items: data.items.map(item => ({
                  key: String(item.key || item.id),
                  id: item.id,
                  name: item.product_title || item.title,
                  price: item.price ? item.price / 100 : 0,
                  price_html: camoFormatMoney(item.line_price),
                  unit_price_html: camoFormatMoney(item.price),
                  quantity: item.quantity,
                  image: item.image || (item.featured_image ? (typeof item.featured_image === 'string' ? item.featured_image : item.featured_image.url) : camoGetAssetUrl('product_camo_calm_serum.png')),
                  url: item.url || '#'
                }))
              };
              camoRenderCart();
            }
          }
        }
      } catch (e) {}
    }
  }
}

function camoRenderWishlist() {
  const countBadges = document.querySelectorAll('.wishlist-count-badge');
  countBadges.forEach(b => b.textContent = CAMO_WISHLIST.length);

  const container = document.getElementById('wishlistItemsList') || document.getElementById('wishlistDrawerItems');
  const countEl = document.getElementById('wishlistItemCount');
  if (countEl) countEl.textContent = `${CAMO_WISHLIST.length} producto${CAMO_WISHLIST.length === 1 ? '' : 's'}`;

  if (!container) return;

  if (CAMO_WISHLIST.length === 0) {
    container.innerHTML = `
      <div style="text-align:center; padding:3.5rem 1rem; color:#7A7274;">
        <p style="font-size:0.92rem; margin-bottom:1rem;">Tu lista de deseos está vacía.</p>
        <a href="#productos" onclick="window.camoApp.closeWishlist()" class="btn btn-terracotta btn-sm" style="display:inline-block; text-decoration:none;">Descubrir Fórmulas</a>
      </div>
    `;
    return;
  }

  container.innerHTML = CAMO_WISHLIST.map(id => {
    const product = CAMO_PRODUCTS[id];
    if (!product) return '';
    return `
      <div style="display:flex; align-items:center; gap:1rem; padding:1rem 0; border-bottom:1px solid rgba(28,23,24,0.06);">
        <img src="${product.image}" alt="${product.name}" style="width:68px; height:68px; object-fit:contain; background:#FFF; border-radius:10px; padding:0.3rem;">
        <div style="flex:1;">
          <div style="font-family:'Plus Jakarta Sans', sans-serif; font-size:0.88rem; font-weight:600; color:#1C1718;">${product.name}</div>
          <div style="font-family:'Plus Jakarta Sans', sans-serif; font-size:0.95rem; font-weight:700; color:#C67A63; margin-top:0.25rem;">${product.price.toFixed(2)} €</div>
          <div style="display:flex; gap:0.5rem; margin-top:0.5rem;">
            <button onclick="window.camoApp.addToCart('${product.id}', 1, true)" class="btn btn-terracotta btn-sm" style="padding:0.35rem 0.85rem; font-size:0.72rem;">Añadir a la Cesta</button>
            <button onclick="window.camoApp.toggleWishlist('${product.id}')" style="border:none; background:none; font-size:0.72rem; color:#A09899; text-decoration:underline; cursor:pointer;">Quitar</button>
          </div>
        </div>
      </div>
    `;
  }).join('');
}

function camoToggleWishlist(productId) {
  const idx = CAMO_WISHLIST.indexOf(productId);
  if (idx > -1) {
    CAMO_WISHLIST.splice(idx, 1);
    camoShowToast('✓ Eliminado de tu lista de deseos');
  } else {
    CAMO_WISHLIST.push(productId);
    camoShowToast('♥ Añadido a tu lista de deseos');
  }
  try {
    localStorage.setItem('camo_wishlist_v1', JSON.stringify(CAMO_WISHLIST));
  } catch (e) {}
  camoRenderWishlist();
}

// Global Clipboard Copy Helper for Discount Coupons
function camoCopyCoupon(code = 'RITUALCAMO', btnEl = null) {
  if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(code).then(() => {
      camoShowToast(`✓ Cupón ${code} copiado al portapapeles (-15% DTO)`);
      if (btnEl) {
        const orig = btnEl.innerHTML;
        btnEl.innerHTML = `<span>✓ Copiado</span>`;
        btnEl.style.background = '#528064';
        setTimeout(() => {
          btnEl.innerHTML = orig;
          btnEl.style.background = '';
        }, 2000);
      }
    }).catch(() => {
      camoFallbackCopyText(code, btnEl);
    });
  } else {
    camoFallbackCopyText(code, btnEl);
  }
}

function camoFallbackCopyText(text, btnEl) {
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.style.position = 'fixed';
  ta.style.opacity = '0';
  document.body.appendChild(ta);
  ta.focus();
  ta.select();
  try {
    document.execCommand('copy');
    camoShowToast(`✓ Cupón ${text} copiado al portapapeles (-15% DTO)`);
    if (btnEl) {
      const orig = btnEl.innerHTML;
      btnEl.innerHTML = `<span>✓ Copiado</span>`;
      btnEl.style.background = '#528064';
      setTimeout(() => {
        btnEl.innerHTML = orig;
        btnEl.style.background = '';
      }, 2000);
    }
  } catch (err) {}
  document.body.removeChild(ta);
}

// Bundle Cross-Sell Checkbox Toggle (Product Page / Quick View)
function camoToggleBundleCard(cardEl) {
  if (!cardEl) return;
  const cb = cardEl.querySelector('.camo-bundle-card-checkbox');
  if (cb && event && event.target !== cb) {
    cb.checked = !cb.checked;
  }
  cardEl.classList.toggle('is-selected', cb ? cb.checked : true);

  const section = cardEl.closest('.camo-bundle-section, .camo-quickview-bundle');
  if (!section) return;

  let sum = 0;
  let count = 0;
  section.querySelectorAll('.camo-bundle-card').forEach(c => {
    const checkbox = c.querySelector('.camo-bundle-card-checkbox');
    if (checkbox && checkbox.checked) {
      c.classList.add('is-selected');
      sum += parseFloat(c.getAttribute('data-product-price') || 0);
      count++;
    } else {
      c.classList.remove('is-selected');
    }
  });

  const oldTotalEl = section.querySelector('.camo-bundle-old-price');
  const newTotalEl = section.querySelector('.camo-bundle-new-price');
  const discountPill = section.querySelector('.camo-bundle-discount-pill');
  const ctaBtn = section.querySelector('.camo-bundle-cta-btn');

  if (count >= 2) {
    const discounted = sum * 0.85;
    if (oldTotalEl) {
      oldTotalEl.style.display = 'inline';
      oldTotalEl.textContent = `${sum.toFixed(2).replace('.', ',')} €`;
    }
    if (newTotalEl) newTotalEl.textContent = `${discounted.toFixed(2).replace('.', ',')} €`;
    if (discountPill) discountPill.style.display = 'inline-flex';
    if (ctaBtn) ctaBtn.innerHTML = `Añadir los ${count} Productos a la Cesta (-15% DTO) &rarr;`;
  } else {
    if (oldTotalEl) oldTotalEl.style.display = 'none';
    if (newTotalEl) newTotalEl.textContent = `${sum.toFixed(2).replace('.', ',')} €`;
    if (discountPill) discountPill.style.display = 'none';
    if (ctaBtn) ctaBtn.innerHTML = `Añadir Selección a la Cesta &rarr;`;
  }
}

// Bundle Cross-Sell Batch Add
async function camoAddBundleToCart(btnEl) {
  const section = btnEl ? btnEl.closest('.camo-bundle-section, .camo-quickview-bundle') : document.querySelector('.camo-bundle-section');
  if (!section) return;

  const cards = section.querySelectorAll('.camo-bundle-card.is-selected, .camo-bundle-card input[type="checkbox"]:checked');
  const selectedProducts = [];

  cards.forEach(c => {
    const cardEl = c.closest('.camo-bundle-card');
    if (!cardEl) return;
    const pid = cardEl.getAttribute('data-product-id') || 'camo-calm-serum';
    const handle = cardEl.getAttribute('data-product-handle') || pid;
    const tit = cardEl.getAttribute('data-product-title') || (cardEl.querySelector('.camo-bundle-card-name')?.textContent.trim()) || 'Fórmula CAMO';
    const prc = parseFloat(cardEl.getAttribute('data-product-price')) || 30.00;
    const img = cardEl.getAttribute('data-product-image') || (cardEl.querySelector('.camo-bundle-card-img')?.src) || '';
    const vid = cardEl.getAttribute('data-variant-id');

    selectedProducts.push({
      id: pid,
      handle: handle,
      title: tit,
      price: prc,
      image: img,
      variantId: vid,
      url: '/products/' + handle
    });
  });

  if (selectedProducts.length === 0) {
    camoShowToast('Selecciona al menos un producto para añadir');
    return;
  }

  // Instant local cart update
  if (!CAMO_LIVE_CART.items) CAMO_LIVE_CART.items = [];

  selectedProducts.forEach(prod => {
    const existing = CAMO_LIVE_CART.items.find(i => 
      String(i.id) === String(prod.id) || 
      (prod.variantId && String(i.id) === String(prod.variantId)) ||
      (prod.handle && i.handle === prod.handle) ||
      (prod.title && i.name && i.name.toLowerCase() === prod.title.toLowerCase())
    );
    if (existing) {
      existing.quantity += 1;
      const unitP = typeof existing.price === 'number' ? existing.price : prod.price;
      existing.price_html = camoFormatMoney(existing.quantity * unitP);
    } else {
      CAMO_LIVE_CART.items.push({
        key: String(prod.variantId || prod.id),
        id: prod.variantId || prod.id,
        name: prod.title,
        price: prod.price,
        unit_price_html: camoFormatMoney(prod.price),
        price_html: camoFormatMoney(prod.price),
        quantity: 1,
        image: prod.image || camoGetAssetUrl('product_camo_calm_serum.png'),
        url: prod.url,
        handle: prod.handle
      });
    }
  });

  // Apply 15% discount & RITUALCAMO code
  CAMO_LIVE_CART.is_ritual_applied = true;
  CAMO_LIVE_CART.discount_code = 'RITUALCAMO';
  CAMO_LIVE_CART.discount_percent = 15;

  let totalCount = 0;
  let totalPrice = 0;
  CAMO_LIVE_CART.items.forEach(it => {
    totalCount += it.quantity;
    const p = typeof it.price === 'number' ? it.price : 30;
    totalPrice += p * it.quantity;
  });
  CAMO_LIVE_CART.item_count = totalCount;
  CAMO_LIVE_CART.subtotal_html = camoFormatMoney(totalPrice * 0.85);

  try { localStorage.setItem('CAMO_LOCAL_CART_V2', JSON.stringify(CAMO_LIVE_CART)); } catch (e) {}
  camoRenderCart();
  camoShowToast(`✨ Rutina de ${selectedProducts.length} fórmulas añadida a tu cesta (-15% DTO cupón RITUALCAMO)`);
  camoOpenCartDrawer();
  camoCloseQuickView();

  // Asynchronous Shopify Backend Sync
  const isShopify = (typeof window !== 'undefined' && (window.Shopify || (window.location && window.location.pathname && (window.location.pathname.includes('/products/') || window.location.pathname.includes('/collections/'))) || (window.location && window.location.hostname && window.location.hostname.includes('myshopify.com'))));
  if (isShopify) {
    const rootPath = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    const itemsToAdd = [];

    for (let prod of selectedProducts) {
      const vId = await camoGetShopifyVariantId(prod.id, prod.handle, prod.title) || prod.variantId;
      if (vId) itemsToAdd.push({ id: vId, quantity: 1 });
    }

    if (itemsToAdd.length > 0) {
      try {
        const sRes = await fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        });
        if (sRes.ok) {
          const cRes = await fetch(rootPath + 'cart.js', { headers: { 'Accept': 'application/json' } });
          if (cRes.ok) {
            const data = await cRes.json();
            if (data && data.items && data.items.length > 0) {
              CAMO_LIVE_CART = {
                item_count: data.item_count,
                subtotal_html: camoFormatMoney(data.total_price),
                is_ritual_applied: true,
                discount_code: 'RITUALCAMO',
                discount_percent: 15,
                items: data.items.map(item => ({
                  key: String(item.key || item.id),
                  id: item.id,
                  name: item.product_title || item.title,
                  price: item.price ? item.price / 100 : 0,
                  price_html: camoFormatMoney(item.line_price),
                  unit_price_html: camoFormatMoney(item.price),
                  quantity: item.quantity,
                  image: item.image || (item.featured_image ? (typeof item.featured_image === 'string' ? item.featured_image : item.featured_image.url) : camoGetAssetUrl('product_camo_calm_serum.png')),
                  url: item.url || '#'
                }))
              };
              camoRenderCart();
            }
          }
        }
      } catch (e) {}
    }
  }
}

function camoOpenQuickView(productId) {
  const product = CAMO_PRODUCTS[productId];
  const modal = document.getElementById('quickViewModal') || document.getElementById('quickViewModalBackdrop');
  const content = document.getElementById('quickViewContent') || document.getElementById('quickViewBody');

  if (!product || !modal || !content) return;

  const ecocertImgUrl = camoGetAssetUrl('ecocert-cosmos-natural.png');

  // Pairings for bundle cross-sell
  const compMap = {
    'camo-calm-mist': ['camo-calm-serum', 'niacinamide'],
    'camo-calm-serum': ['camo-calm-mist', 'niacinamide'],
    'reti-glow': ['purifying-mousse', 'peeling-enzimatico'],
    'niacinamide': ['purifying-mousse', 'camo-calm-serum'],
    'peeling-enzimatico': ['purifying-mousse', 'reti-glow'],
    'purifying-mousse': ['camo-calm-mist', 'niacinamide'],
    'lip-mask': ['camo-calm-mist', 'reti-glow']
  };
  const pairKeys = compMap[productId] || ['camo-calm-serum', 'niacinamide'];
  const p2 = CAMO_PRODUCTS[pairKeys[0]] || CAMO_PRODUCTS['camo-calm-serum'];
  const p3 = CAMO_PRODUCTS[pairKeys[1]] || CAMO_PRODUCTS['niacinamide'];
  const bundleSum = product.price + (p2 ? p2.price : 25) + (p3 ? p3.price : 49);
  const bundleDiscounted = bundleSum * 0.85;

  content.innerHTML = `
    <div style="display:grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap:2rem; align-items:start; text-align:left;">
      <div style="background:#FAF7F2; border-radius:18px; padding:1.5rem; text-align:center; border:1px solid rgba(28,23,24,0.05); position:relative;">
        <img src="${product.image}" alt="${product.name}" style="max-height:260px; width:auto; max-width:100%; object-fit:contain; margin:0 auto; display:block;">
        
        <div style="margin-top:1.25rem; display:inline-flex; align-items:center; gap:0.5rem; background:#FFF; border:1px solid rgba(198,122,99,0.3); padding:0.35rem 0.85rem; border-radius:50px; box-shadow:0 2px 8px rgba(0,0,0,0.04);">
          <img src="${ecocertImgUrl}" alt="ECOCERT COSMOS NATURAL" style="height:22px; width:auto; object-fit:contain;">
          <span style="font-size:0.68rem; font-weight:700; text-transform:uppercase; letter-spacing:0.08em; color:#1C1718;">Certificado ECOCERT®</span>
        </div>
      </div>
      <div>
        <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:0.4rem; gap:0.5rem; flex-wrap:wrap;">
          <span style="font-size:0.72rem; font-weight:700; text-transform:uppercase; letter-spacing:0.1em; color:#C67A63;">${product.category} · ${product.volume}</span>
          <span style="font-size:0.68rem; font-weight:700; background:rgba(198,122,99,0.12); color:#C67A63; padding:0.15rem 0.5rem; border-radius:4px;">COSMOS NATURAL</span>
        </div>
        <h2 style="font-family:'Cormorant Garamond', Georgia, serif; font-size:1.75rem; font-weight:600; color:#1C1718; line-height:1.2; margin:0 0 0.5rem;">${product.name}</h2>
        <div style="font-family:'Plus Jakarta Sans', sans-serif; font-size:1.4rem; font-weight:700; color:#C67A63; margin-bottom:0.85rem;">${product.price.toFixed(2)} €</div>
        <p style="font-size:0.85rem; color:#6B6365; line-height:1.6; margin-bottom:1rem;">${product.fullDesc}</p>
        
        <!-- ECOCERT Official Guarantee Box -->
        <div style="background:linear-gradient(135deg, #FAF7F2 0%, #F5EFE6 100%); border:1px solid rgba(198,122,99,0.3); border-radius:12px; padding:0.85rem 1rem; margin-bottom:1.15rem; display:flex; align-items:center; gap:0.85rem;">
          <img src="${ecocertImgUrl}" alt="ECOCERT COSMOS NATURAL" style="height:36px; width:auto; object-fit:contain; flex-shrink:0;">
          <div style="font-size:0.75rem; color:#4A4244; line-height:1.45;">
            <strong style="color:#1C1718; display:block; font-size:0.78rem;">Sello Oficial ECOCERT® COSMOS NATURAL</strong>
            100% origen botánico de alta pureza · 0% siliconas, sulfatos y tóxicos · Cruelty Free.
          </div>
        </div>

        <div style="margin-bottom:1.25rem;">
          <div style="font-size:0.72rem; font-weight:700; text-transform:uppercase; letter-spacing:0.08em; color:#1C1718; margin-bottom:0.4rem;">Activos Principales:</div>
          <ul style="padding-left:1.1rem; font-size:0.78rem; color:#4A4244; line-height:1.55; margin:0;">
            ${product.keyIngredients.map(ing => `<li><strong>${ing.name}:</strong> ${ing.desc}</li>`).join('')}
          </ul>
        </div>

        <button onclick="window.camoApp.addToCart('${product.id}', 1, true); window.camoApp.closeQuickView();" class="btn btn-terracotta" style="width:100%; padding:0.9rem 1.5rem; font-size:0.85rem; font-weight:700; text-transform:uppercase; letter-spacing:0.08em; margin-bottom:1.5rem;">
          Añadir a la Cesta · ${product.price.toFixed(2)} €
        </button>

        <!-- Completa tu Ritual Cross-Sell Box with RITUALCAMO Coupon -->
        <div class="camo-quickview-bundle" style="background:#FAF7F2; border:1px solid rgba(198,122,99,0.3); border-radius:14px; padding:1.15rem;">
          <div style="font-size:0.72rem; font-weight:700; text-transform:uppercase; letter-spacing:0.1em; color:#C67A63; margin-bottom:0.3rem;">✨ Completa tu Ritual · Combínalo con:</div>
          <div style="font-size:0.8rem; color:#5A5254; margin-bottom:0.75rem;">Añade estas 2 fórmulas complementarias con un <strong>15% de descuento</strong>:</div>
          
          <div style="display:flex; gap:0.6rem; align-items:center; margin-bottom:0.85rem;">
            <div style="background:#FFF; padding:0.3rem; border-radius:8px; border:1px solid rgba(28,23,24,0.06); text-align:center; flex:1;">
              <img src="${p2.image}" alt="${p2.name}" style="width:40px; height:40px; object-fit:contain; margin:0 auto; display:block;">
              <div style="font-size:0.68rem; font-weight:700; color:#1C1718; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">${p2.name}</div>
              <div style="font-size:0.72rem; color:#C67A63; font-weight:700;">${p2.price.toFixed(2)} €</div>
            </div>
            <span style="color:#C67A63; font-weight:700;">+</span>
            <div style="background:#FFF; padding:0.3rem; border-radius:8px; border:1px solid rgba(28,23,24,0.06); text-align:center; flex:1;">
              <img src="${p3.image}" alt="${p3.name}" style="width:40px; height:40px; object-fit:contain; margin:0 auto; display:block;">
              <div style="font-size:0.68rem; font-weight:700; color:#1C1718; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">${p3.name}</div>
              <div style="font-size:0.72rem; color:#C67A63; font-weight:700;">${p3.price.toFixed(2)} €</div>
            </div>
          </div>

          <!-- Coupon Copy Pill -->
          <div style="display:flex; justify-content:space-between; align-items:center; background:#FFF; border:1px dashed #C67A63; padding:0.4rem 0.75rem; border-radius:8px; margin-bottom:0.75rem;">
            <span style="font-size:0.72rem; color:#5A5254;">Cupón 15% DTO: <strong style="color:#C67A63; font-family:'Plus Jakarta Sans', monospace;">RITUALCAMO</strong></span>
            <button type="button" onclick="window.camoCopyCoupon('RITUALCAMO', this)" style="border:none; background:#C67A63; color:#FFF; border-radius:50px; padding:0.2rem 0.6rem; font-size:0.68rem; font-weight:700; cursor:pointer;">Copiar</button>
          </div>

          <button type="button" onclick="window.camoApp.addToCart('${product.id}', 1, false); window.camoApp.addToCart('${p2.id}', 1, false); window.camoApp.addToCart('${p3.id}', 1, true); window.camoApp.closeQuickView();" class="btn btn-outline-terracotta btn-sm" style="width:100%; border-radius:50px; font-size:0.76rem; font-weight:700; padding:0.6rem; background:#C67A63; color:#FFF; border:none; cursor:pointer;">
            Añadir los 3 Productos con 15% DTO (${bundleDiscounted.toFixed(2).replace('.', ',')} €) &rarr;
          </button>
        </div>

      </div>
    </div>
  `;

  modal.style.display = 'flex';
  modal.style.visibility = 'visible';
  modal.style.opacity = '1';
  modal.classList.add('is-open');
  document.body.style.overflow = 'hidden';
}

function camoCloseQuickView() {
  const modal = document.getElementById('quickViewModal') || document.getElementById('quickViewModalBackdrop');
  if (modal) {
    modal.classList.remove('is-open');
    setTimeout(() => {
      if (!modal.classList.contains('is-open')) {
        modal.style.display = 'none';
      }
    }, 300);
    document.body.style.overflow = '';
  }
}

function camoFilterProducts(category, btnEl) {
  const activeCat = (category || 'all').toLowerCase();

  // 1. Sync button active states
  document.querySelectorAll('.filter-tab-btn').forEach(b => {
    const bFilter = (b.getAttribute('data-filter') || '').toLowerCase();
    if (b === btnEl || bFilter === activeCat) {
      b.classList.add('is-active');
    } else {
      b.classList.remove('is-active');
    }
  });

  // 2. Filter product cards
  const cards = document.querySelectorAll('.product-card');
  let visibleCount = 0;

  cards.forEach((card, index) => {
    const cardCat = (card.getAttribute('data-category') || '').toLowerCase();
    const cardLine = (card.getAttribute('data-line') || '').toLowerCase();
    const cardTitle = (card.querySelector('.product-name') ? card.querySelector('.product-name').textContent : '').toLowerCase();
    const cardId = (card.id || '').toLowerCase();

    let matches = false;

    if (activeCat === 'all') {
      matches = true;
    } else if (activeCat === 'renew' || activeCat === 'glow') {
      matches = (cardLine === 'renew' || cardCat === 'renew' || cardCat === 'glow' || 
                 cardTitle.includes('renew') || cardTitle.includes('reti') || cardTitle.includes('bakuchiol') || cardId.includes('reti-glow') || cardId.includes('renew'));
    } else if (activeCat === 'calm') {
      matches = (cardLine === 'calm' || cardCat === 'calm' || 
                 cardTitle.includes('calm') || cardTitle.includes('prebiotic') || cardTitle.includes('ceramide') || cardTitle.includes('bruma') || cardTitle.includes('mist') || cardId.includes('calm'));
    } else if (activeCat === 'hydra') {
      matches = (cardLine === 'hydra' || cardCat === 'hydra' || 
                 cardTitle.includes('hydra') || cardTitle.includes('niacinamide') || cardTitle.includes('hialur') || cardId.includes('niacinamide') || cardId.includes('hydra'));
    } else if (activeCat === 'packs') {
      matches = (cardLine === 'packs' || cardCat === 'packs' || 
                 cardTitle.includes('pack') || cardTitle.includes('duo') || cardTitle.includes('dúo') || cardTitle.includes('set') || cardTitle.includes('ritual') || cardId.includes('pack'));
    } else if (activeCat === 'clean') {
      matches = (cardLine === 'clean' || cardCat === 'clean' || 
                 cardTitle.includes('peeling') || cardTitle.includes('mousse') || cardTitle.includes('lip') || cardId.includes('peeling') || cardId.includes('mousse') || cardId.includes('lip'));
    }

    if (matches) {
      card.style.display = 'flex';
      card.classList.remove('is-hidden');
      visibleCount++;
    } else {
      card.style.display = 'none';
      card.classList.add('is-hidden');
    }
  });

  if (activeCat === 'all' && document.getElementById('featuredProductsGrid')) {
    let heroCount = 0;
    cards.forEach(c => {
      heroCount++;
      if (heroCount <= 4) {
        c.style.display = 'flex';
      } else {
        c.style.display = 'none';
      }
    });
  }
}

// Live Camera & Scanner
let camoMediaStream = null;

async function camoStartLiveCamera() {
  const scanVideo = document.getElementById('skinaiVideo');
  const scanImage = document.getElementById('skinaiImage');

  try {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      camoMediaStream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'user', width: { ideal: 640 }, height: { ideal: 480 } }
      });
      if (scanVideo) {
        scanVideo.srcObject = camoMediaStream;
        scanVideo.setAttribute('playsinline', '');
        scanVideo.setAttribute('autoplay', '');
        scanVideo.setAttribute('muted', '');
        scanVideo.style.display = 'block';
        if (scanImage) scanImage.style.display = 'none';
        scanVideo.play();
      }
      camoTriggerScanSequence('Cámara en vivo');
    } else {
      camoTriggerFallbackScan('Simulación Biométrica');
    }
  } catch (err) {
    console.warn('Camera access denied or unavailable. Fallback to model portrait.', err);
    camoTriggerFallbackScan('Análisis de Fotografía');
  }
}

function camoTriggerFallbackScan(modeName) {
  const scanVideo = document.getElementById('skinaiVideo');
  const scanImage = document.getElementById('skinaiImage');
  if (scanVideo) scanVideo.style.display = 'none';
  if (scanImage) {
    scanImage.style.display = 'block';
    scanImage.src = camoGetAssetUrl('camo_model_glow.jpg');
  }
  camoTriggerScanSequence(modeName);
}

function camoTriggerScanSequence(modeLabel) {
  const scannerCard = document.getElementById('scannerCard');
  const statusText = document.getElementById('scanStatusText');
  const diagnosticResultOverlay = document.getElementById('diagnosticResultOverlay');

  if (!scannerCard) return;

  scannerCard.classList.add('is-scanning');
  if (diagnosticResultOverlay) diagnosticResultOverlay.style.display = 'none';

  const steps = [
    { text: `⚡ Calibrando sensor óptico (${modeLabel})...`, duration: 900 },
    { text: '🔍 Mapeando 68 puntos biométricos faciales...', duration: 1100 },
    { text: '💧 Analizando nivel de deshidratación y micro-textura...', duration: 1100 },
    { text: '🌿 Evaluando reactividad, tono y barrera cutánea...', duration: 1000 },
    { text: '✨ Formulando diagnóstico botánico a medida...', duration: 900 }
  ];

  let currentStep = 0;

  function nextStep() {
    if (currentStep < steps.length) {
      if (statusText) statusText.textContent = steps[currentStep].text;
      setTimeout(() => {
        currentStep++;
        nextStep();
      }, steps[currentStep].duration);
    } else {
      camoFinishScan();
    }
  }

  nextStep();
}

function camoFinishScan() {
  const scannerCard = document.getElementById('scannerCard');
  const statusText = document.getElementById('scanStatusText');
  const diagnosticResultOverlay = document.getElementById('diagnosticResultOverlay');

  if (scannerCard) scannerCard.classList.remove('is-scanning');
  if (statusText) statusText.textContent = '✓ Diagnóstico completado';

  if (diagnosticResultOverlay) {
    diagnosticResultOverlay.style.display = 'block';
    diagnosticResultOverlay.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  camoShowToast('✨ Lectura de piel completada: Ritual Recomendado Listo');
}


// SkinAI Helpers & Quiz Handlers
let camoQuizState = { step1: 'calm', step2: 'dry', step3: 'complete' };

function camoSelectQuizOption(step, choice) {
  if (step === 1) camoQuizState.step1 = choice;
  if (step === 2) camoQuizState.step2 = choice;
  if (step === 3) camoQuizState.step3 = choice;

  // Update progress bars
  for (let i = 1; i <= 4; i++) {
    const bar = document.getElementById('quizBar' + i);
    if (bar) {
      bar.style.background = i <= (step + 1) ? '#C67A63' : 'rgba(28,23,24,0.1)';
    }
  }

  // Switch step views
  const currentPane = document.getElementById('quizStep' + step);
  const nextPane = document.getElementById('quizStep' + (step + 1));
  if (currentPane) currentPane.style.display = 'none';
  if (nextPane) nextPane.style.display = 'block';
}

// SkinAI Complete Ritual Add (Batch add all 3 distinct recommended formulas with exact Shopify variant IDs)
async function camoAddSkinAIRitualToCart() {
  const ritualProducts = [
    {
      id: 'camo-calm-mist',
      handle: 'bruma-facial-prebioticos-calm',
      title: 'CAMO CALM Barrier Defense Mist (100ml)',
      price: 27.00,
      variantId: 54630657720658,
      image: 'https://cdn.shopify.com/s/files/1/0911/1342/3186/files/bruma_mist.png?v=1788958569',
      url: '/products/bruma-facial-prebioticos-calm'
    },
    {
      id: 'camo-calm-serum',
      handle: 'bioactive-prebiotics-jelly-serum',
      title: 'Bioactive Prebiotics Jelly Serum (30ml)',
      price: 30.00,
      variantId: 54626807447890,
      image: 'https://cdn.shopify.com/s/files/1/0911/1342/3186/files/bioactive_serum.png?v=1788952122',
      url: '/products/bioactive-prebiotics-jelly-serum'
    },
    {
      id: 'niacinamide',
      handle: 'niacinamide-gel-moisturiser-vitamina-b3-y-extracto-de-ginkgo-50ml',
      title: 'Niacinamide Gel Moisturiser (50ml)',
      price: 49.00,
      variantId: 54638984954194,
      image: 'https://cdn.shopify.com/s/files/1/0911/1342/3186/files/upload-1788980578106.png?v=1788980582',
      url: '/products/niacinamide-gel-moisturiser-vitamina-b3-y-extracto-de-ginkgo-50ml'
    }
  ];

  // 1. Instant local cart update with all 3 distinct formulas
  if (!CAMO_LIVE_CART.items) CAMO_LIVE_CART.items = [];

  ritualProducts.forEach(prod => {
    const existing = CAMO_LIVE_CART.items.find(i => 
      String(i.id) === String(prod.id) || 
      String(i.id) === String(prod.variantId) ||
      (prod.handle && i.handle === prod.handle) ||
      (prod.title && i.name && i.name.toLowerCase() === prod.title.toLowerCase())
    );
    if (existing) {
      existing.quantity += 1;
      const unitP = typeof existing.price === 'number' ? existing.price : prod.price;
      existing.price_html = camoFormatMoney(existing.quantity * unitP);
    } else {
      CAMO_LIVE_CART.items.push({
        key: String(prod.variantId || prod.id),
        id: prod.variantId || prod.id,
        name: prod.title,
        price: prod.price,
        unit_price_html: camoFormatMoney(prod.price),
        price_html: camoFormatMoney(prod.price),
        quantity: 1,
        image: prod.image,
        url: prod.url,
        handle: prod.handle
      });
    }
  });

  // Apply 15% discount when SkinAI ritual is added
  CAMO_LIVE_CART.is_ritual_applied = true;
  CAMO_LIVE_CART.discount_code = 'RITUALCAMO';
  CAMO_LIVE_CART.discount_percent = 15;

  let totalCount = 0;
  let totalPrice = 0;
  CAMO_LIVE_CART.items.forEach(it => {
    totalCount += it.quantity;
    const p = typeof it.price === 'number' ? it.price : 30;
    totalPrice += p * it.quantity;
  });
  CAMO_LIVE_CART.item_count = totalCount;
  CAMO_LIVE_CART.subtotal_html = camoFormatMoney(totalPrice * 0.85);

  try { localStorage.setItem('CAMO_LOCAL_CART_V2', JSON.stringify(CAMO_LIVE_CART)); } catch (e) {}
  camoRenderCart();
  camoShowToast('✨ Ritual SkinAI™ (3 fórmulas) añadido a tu cesta (-15% DTO cupón RITUALCAMO)');
  camoOpenCartDrawer();
  camoCloseSkinAIModal();

  // 2. Shopify Asynchronous Backend Batch Sync
  const isShopify = (typeof window !== 'undefined' && (window.Shopify || (window.location && window.location.pathname && (window.location.pathname.includes('/products/') || window.location.pathname.includes('/collections/'))) || (window.location && window.location.hostname && window.location.hostname.includes('myshopify.com'))));
  
  if (isShopify) {
    const rootPath = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    const itemsToAdd = [];

    for (let prod of ritualProducts) {
      const vId = await camoGetShopifyVariantId(prod.id, prod.handle, prod.title) || prod.variantId;
      if (vId) {
        itemsToAdd.push({ id: vId, quantity: 1 });
      }
    }

    if (itemsToAdd.length > 0) {
      try {
        const sRes = await fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        });
        if (sRes.ok) {
          const cRes = await fetch(rootPath + 'cart.js', { headers: { 'Accept': 'application/json' } });
          if (cRes.ok) {
            const data = await cRes.json();
            if (data && data.items && data.items.length > 0) {
              CAMO_LIVE_CART = {
                item_count: data.item_count,
                subtotal_html: camoFormatMoney(data.total_price),
                is_ritual_applied: true,
                discount_code: 'RITUALCAMO',
                discount_percent: 15,
                items: data.items.map(item => ({
                  key: String(item.key || item.id),
                  id: item.id,
                  name: item.product_title || item.title,
                  price: item.price ? item.price / 100 : 0,
                  price_html: camoFormatMoney(item.line_price),
                  unit_price_html: camoFormatMoney(item.price),
                  quantity: item.quantity,
                  image: item.image || (item.featured_image ? (typeof item.featured_image === 'string' ? item.featured_image : item.featured_image.url) : camoGetAssetUrl('product_camo_calm_serum.png')),
                  url: item.url || '#'
                }))
              };
              camoRenderCart();
            }
          }
        }
      } catch (e) {}
    }
  }
}

function camoResetSkinAIScanner() {
  const diagnosticResultOverlay = document.getElementById('diagnosticResultOverlay');
  if (diagnosticResultOverlay) diagnosticResultOverlay.style.display = 'none';
  const statusText = document.getElementById('scanStatusText');
  if (statusText) statusText.textContent = 'Presiona Iniciar Cámara o Diagnóstico';
  camoStartLiveCamera();
}

function camoOpenSkinAIModal() {
  const modal = document.getElementById('skinAiModal') || document.getElementById('skinaiModal');
  if (modal) {
    modal.style.display = 'flex';
    modal.style.visibility = 'visible';
    modal.style.opacity = '1';
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  } else {
    const sec = document.getElementById('camo-skinai');
    if (sec) sec.scrollIntoView({ behavior: 'smooth' });
  }
}

function camoCloseSkinAIModal() {
  const modal = document.getElementById('skinAiModal') || document.getElementById('skinaiModal');
  if (modal) {
    modal.classList.remove('is-open');
    setTimeout(() => {
      if (!modal.classList.contains('is-open')) {
        modal.style.display = 'none';
      }
    }, 300);
    document.body.style.overflow = '';
  }
}

// Hero Slider Functions
function camoGoToHeroSlide(index) {
  const slides = document.querySelectorAll('.hero-slide');
  const dots = document.querySelectorAll('.hero-dot');
  const counterNum = document.getElementById('heroCurrentNum');
  if (!slides.length) return;
  heroCurrentIndex = (index + slides.length) % slides.length;

  slides.forEach((slide, i) => {
    if (i === heroCurrentIndex) {
      slide.classList.add('is-active');
      slide.style.opacity = '1';
      slide.style.visibility = 'visible';
      slide.style.transform = 'scale(1)';
    } else {
      slide.classList.remove('is-active');
      slide.style.opacity = '0';
      slide.style.visibility = 'hidden';
      slide.style.transform = 'scale(1.04)';
    }
  });

  dots.forEach((dot, i) => {
    if (i === heroCurrentIndex) {
      dot.classList.add('is-active');
    } else {
      dot.classList.remove('is-active');
    }
  });

  if (counterNum) {
    counterNum.textContent = String(heroCurrentIndex + 1).padStart(2, '0');
  }
  camoResetHeroAutoplay();
}

function camoNextHeroSlide() {
  const slides = document.querySelectorAll('.hero-slide');
  camoGoToHeroSlide(heroCurrentIndex + 1);
}

function camoPrevHeroSlide() {
  const slides = document.querySelectorAll('.hero-slide');
  camoGoToHeroSlide(heroCurrentIndex - 1);
}

function camoResetHeroAutoplay() {
  if (heroAutoplayTimer) clearInterval(heroAutoplayTimer);
  heroAutoplayTimer = setInterval(() => {
    camoNextHeroSlide();
  }, HERO_AUTOPLAY_DELAY);
}

// Reviews Toggle & Filter
let camoReviewsExpanded = false;

function camoToggleMoreReviews() {
  camoReviewsExpanded = !camoReviewsExpanded;
  const extraCards = document.querySelectorAll('.review-extra-card');
  const textEl = document.getElementById('toggleReviewsText');
  const arrowEl = document.getElementById('toggleReviewsArrow');

  extraCards.forEach(card => {
    if (camoReviewsExpanded) {
      card.style.display = 'flex';
      card.style.opacity = '0';
      card.style.transform = 'translateY(12px)';
      setTimeout(() => {
        card.style.opacity = '1';
        card.style.transform = 'translateY(0)';
      }, 40);
    } else {
      card.style.display = 'none';
    }
  });

  if (textEl) textEl.textContent = camoReviewsExpanded ? 'Ver menos opiniones' : 'Ver más opiniones de clientas (+4)';
  if (arrowEl) arrowEl.textContent = camoReviewsExpanded ? '▴' : '▾';
}

function camoFilterReviews(type, btn) {
  document.querySelectorAll('.reviews-filter-bar .filter-chip').forEach(b => b.classList.remove('active'));
  if (btn) btn.classList.add('active');

  const cards = document.querySelectorAll('.reviews-cards-grid .review-card');
  const toggleBtn = document.getElementById('toggleMoreReviewsBtn');

  if (type === 'all') {
    cards.forEach((card, index) => {
      if (index < 2 || camoReviewsExpanded) {
        card.style.display = 'flex';
        card.style.opacity = '1';
        card.style.transform = 'translateY(0)';
      } else {
        card.style.display = 'none';
      }
    });
    if (toggleBtn && toggleBtn.parentElement) toggleBtn.parentElement.style.display = 'block';
  } else {
    cards.forEach(card => {
      const cardType = card.getAttribute('data-skin-type');
      if (cardType === type) {
        card.style.display = 'flex';
        card.style.opacity = '0';
        card.style.transform = 'translateY(12px)';
        setTimeout(() => {
          card.style.opacity = '1';
          card.style.transform = 'translateY(0)';
        }, 40);
      } else {
        card.style.display = 'none';
      }
    });
    if (toggleBtn && toggleBtn.parentElement) toggleBtn.parentElement.style.display = 'none';
  }
}

// Routine Builder Controls
function camoToggleRoutineCard(cardEl) {
  if (!cardEl) return;
  cardEl.classList.toggle('is-selected');
  camoRecalculateRoutineTotal();
}

function camoRecalculateRoutineTotal() {
  const cards = document.querySelectorAll('.routine-product-card.is-selected');
  let sum = 0;
  cards.forEach(card => {
    sum += parseFloat(card.getAttribute('data-price') || 0);
  });

  const countEl = document.getElementById('routineSelectedCount');
  const oldTotalEl = document.getElementById('routineOldTotal');
  const discountedTotalEl = document.getElementById('routineDiscountedTotal');
  const discountPill = document.getElementById('routineDiscountPill');

  if (countEl) countEl.textContent = cards.length;

  if (cards.length >= 2) {
    const discounted = sum * 0.85;
    if (oldTotalEl) {
      oldTotalEl.style.display = 'inline';
      oldTotalEl.textContent = `${sum.toFixed(2).replace('.', ',')} €`;
    }
    if (discountedTotalEl) discountedTotalEl.textContent = `${discounted.toFixed(2).replace('.', ',')} €`;
    if (discountPill) discountPill.style.display = 'inline-flex';
  } else {
    if (oldTotalEl) oldTotalEl.style.display = 'none';
    if (discountedTotalEl) discountedTotalEl.textContent = `${sum.toFixed(2).replace('.', ',')} €`;
    if (discountPill) discountPill.style.display = 'none';
  }
}

function camoToggleAllProductsGrid() {
  const extraCards = document.querySelectorAll('.product-extra-card');
  const textEl = document.getElementById('toggleAllProductsText');
  const arrowEl = document.getElementById('toggleAllProductsArrow');
  let anyHidden = false;

  extraCards.forEach(card => {
    if (card.style.display === 'none' || card.classList.contains('is-hidden')) {
      anyHidden = true;
    }
  });

  if (anyHidden) {
    extraCards.forEach(card => {
      card.style.display = 'flex';
      card.classList.remove('is-hidden');
    });
    if (textEl) textEl.textContent = 'Ver Solo los Favoritos Más Vendidos';
    if (arrowEl) arrowEl.textContent = '▴';
  } else {
    extraCards.forEach(card => {
      card.style.display = 'none';
      card.classList.add('is-hidden');
    });
    if (textEl) textEl.textContent = 'Ver Toda la Colección de Tratamientos (7 Fórmulas)';
    if (arrowEl) arrowEl.textContent = '→';
  }
}

function camoOpenMobileNav() {
  const backdrop = document.getElementById('mobileNavDrawerBackdrop');
  if (backdrop) {
    backdrop.style.setProperty('display', 'flex', 'important');
    backdrop.style.setProperty('opacity', '1', 'important');
    backdrop.style.setProperty('visibility', 'visible', 'important');
    backdrop.style.setProperty('pointer-events', 'auto', 'important');
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
}

function camoCloseMobileNav() {
  const backdrop = document.getElementById('mobileNavDrawerBackdrop');
  if (backdrop) {
    backdrop.classList.remove('is-open');
    backdrop.style.opacity = '';
    backdrop.style.visibility = '';
    backdrop.style.pointerEvents = '';
    setTimeout(() => {
      if (!backdrop.classList.contains('is-open')) {
        backdrop.style.setProperty('display', 'none', 'important');
      }
    }, 350);
    document.body.style.overflow = '';
  }
}

function camoToggleDesktopDropdown(e) {
  if (e) {
    if (e.preventDefault) e.preventDefault();
    if (e.stopPropagation) e.stopPropagation();
  }
  if (typeof window !== 'undefined' && window.innerWidth <= 900) {
    camoOpenMobileNav();
    return;
  }
  const menu = document.getElementById('navDropdownMenu') || document.getElementById('desktopDropdownMenu') || document.querySelector('.nav-dropdown-menu');
  const trigger = document.getElementById('dropdownTriggerBtn') || document.querySelector('.nav-dropdown-trigger');
  if (menu) {
    const willOpen = !menu.classList.contains('is-open');
    menu.classList.toggle('is-open');
    if (trigger) {
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    }
  }
}

// Bind Global window.camoApp object immediately
Object.assign(window.camoApp, {
  getCart: () => CAMO_LIVE_CART,
  fetchLiveCart: camoFetchLiveCart,
  addToCart: camoAddToCart,
  updateLiveQty: camoUpdateCartItemQty,
  removeLiveItem: camoRemoveCartItem,
  openCart: camoOpenCartDrawer,
  closeCart: camoCloseCartDrawer,
  openWishlist: camoOpenWishlistDrawer,
  closeWishlist: camoCloseWishlistDrawer,
  toggleWishlist: camoToggleWishlist,
  openQuickView: camoOpenQuickView,
  closeQuickView: camoCloseQuickView,
  filterProducts: camoFilterProducts,
  startCamera: camoStartLiveCamera,
  startLiveCamera: camoStartLiveCamera,
  resetSkinAIScanner: camoResetSkinAIScanner,
  addSkinAIRitualToCart: camoAddSkinAIRitualToCart,
  selectQuizOption: camoSelectQuizOption,
  openSkinAIModal: camoOpenSkinAIModal,
  closeSkinAIModal: camoCloseSkinAIModal,
  showToast: camoShowToast,
  addBuiltRoutineToShopify: camoAddBuiltRoutineToShopify,
  toggleRoutineCard: camoToggleRoutineCard,
  recalculateRoutineTotal: camoRecalculateRoutineTotal,
  toggleMoreReviews: camoToggleMoreReviews,
  filterReviews: camoFilterReviews,
  toggleAllProductsGrid: camoToggleAllProductsGrid,
  openMobileNav: camoOpenMobileNav,
  closeMobileNav: camoCloseMobileNav,
  toggleDesktopDropdown: camoToggleDesktopDropdown,
  copyCoupon: camoCopyCoupon,
  addBundleToCart: camoAddBundleToCart,
  toggleBundleCard: camoToggleBundleCard,
  goToHeroSlide: camoGoToHeroSlide,
  nextHeroSlide: camoNextHeroSlide,
  prevHeroSlide: camoPrevHeroSlide,
  resetHeroAutoplay: camoResetHeroAutoplay
});

// Also expose directly on window root for maximum compatibility
window.camoAddToCart = camoAddToCart;
window.camoOpenCart = camoOpenCartDrawer;
window.camoCloseCart = camoCloseCartDrawer;
window.camoFilterProducts = camoFilterProducts;
window.camoCopyCoupon = camoCopyCoupon;
window.camoAddBundleToCart = camoAddBundleToCart;
window.camoToggleBundleCard = camoToggleBundleCard;

// DOM Ready Initialization
document.addEventListener('DOMContentLoaded', () => {

  // Form submission interceptor for native product forms (Shopify / WooCommerce / Standalone)
  document.addEventListener('submit', async function(e) {
    const form = e.target;
    if (form && (form.action.includes('/cart/add') || form.id === 'camoProductForm' || form.classList.contains('camo-product-form') || form.classList.contains('camo-card-form'))) {
      e.preventDefault();
      e.stopPropagation();
      
      const submitBtn = form.querySelector('button[type="submit"], #camoAddToCartBtn, .single_add_to_cart_button, .btn-terracotta');
      const origText = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = 'Añadiendo...';
      }
      
      const qtyInput = form.querySelector('input[name="quantity"], #productQty');
      const qty = (qtyInput ? parseInt(qtyInput.value) : 1) || 1;
      
      try {
        await camoAddToCart(form, qty, true);
      } catch (err) {
        console.error('Add to cart submit error:', err);
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = origText || 'Añadir a la Cesta &rarr;';
        }
      }
    }
  });

  // Bind Cart Triggers
  // Global delegated click listener for any add-to-cart buttons
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.camo-hover-cart-btn, .add_to_cart_button, .ajax_add_to_cart, [data-action="add-to-cart"], .single_add_to_cart_button');
    if (btn) {
      if (!btn.getAttribute('onclick')) {
        e.preventDefault();
        e.stopPropagation();
        camoAddToCart(btn, 1, true);
      }
    }
  });

  document.querySelectorAll('.open-cart-btn, [data-action="open-cart"], #headerCartBtn, .header-action-btn.open-cart-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      camoOpenCartDrawer();
    });
  });

  const cartCloseBtn = document.getElementById('cartCloseBtn');
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', camoCloseCartDrawer);

  const cartBackdrop = document.getElementById('cartDrawerBackdrop') || document.querySelector('.cart-drawer-backdrop');
  if (cartBackdrop) {
    cartBackdrop.addEventListener('click', (e) => {
      if (e.target === cartBackdrop) camoCloseCartDrawer();
    });
  }

  // Bind Wishlist Triggers
  const openWishlistBtn = document.getElementById('openWishlistBtn');
  if (openWishlistBtn) {
    openWishlistBtn.addEventListener('click', (e) => {
      e.preventDefault();
      camoOpenWishlistDrawer();
    });
  }

  const wishlistCloseBtn = document.getElementById('wishlistCloseBtn');
  if (wishlistCloseBtn) wishlistCloseBtn.addEventListener('click', camoCloseWishlistDrawer);

  const wishlistBackdrop = document.getElementById('wishlistDrawerBackdrop') || document.querySelector('.wishlist-drawer-backdrop');
  if (wishlistBackdrop) {
    wishlistBackdrop.addEventListener('click', (e) => {
      if (e.target === wishlistBackdrop) camoCloseWishlistDrawer();
    });
  }

  // Bind Quick View Close
  const closeQuickViewBtn = document.getElementById('closeQuickViewBtn');
  const quickViewModal = document.getElementById('quickViewModal') || document.getElementById('quickViewModalBackdrop');
  if (closeQuickViewBtn && quickViewModal) {
    closeQuickViewBtn.addEventListener('click', camoCloseQuickView);
    quickViewModal.addEventListener('click', (e) => {
      if (e.target === quickViewModal) camoCloseQuickView();
    });
  }

  // Intercept WooCommerce native AJAX added_to_cart event
  if (typeof jQuery !== 'undefined') {
    jQuery(document.body).on('added_to_cart', function(event, fragments, cart_hash, $button) {
      camoFetchLiveCart(true);
    });
    jQuery(document.body).on('removed_from_cart', function() {
      camoFetchLiveCart(false);
    });
  }

  // Close desktop dropdown on click outside
  document.addEventListener('click', function(e) {
    const menu = document.getElementById('navDropdownMenu') || document.getElementById('desktopDropdownMenu');
    const dropdownWrap = document.getElementById('navCollectionsDropdown');
    if (menu && dropdownWrap && !dropdownWrap.contains(e.target)) {
      menu.classList.remove('is-open');
    }
  });

  // Hero Touch Gestures & Mouse Pause
  const heroSectionEl = document.getElementById('heroSection') || document.querySelector('.hero-section');
  if (heroSectionEl) {
    let touchStartX = 0;
    let touchEndX = 0;

    heroSectionEl.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    heroSectionEl.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      if (touchEndX < touchStartX - 45) {
        camoNextHeroSlide();
      }
      if (touchEndX > touchStartX + 45) {
        camoPrevHeroSlide();
      }
    }, { passive: true });

    heroSectionEl.addEventListener('mouseenter', () => {
      if (heroAutoplayTimer) clearInterval(heroAutoplayTimer);
    });

    heroSectionEl.addEventListener('mouseleave', () => {
      camoResetHeroAutoplay();
    });
  }

  // Start Autoplay
  camoResetHeroAutoplay();

  // Smooth Scroll & Offset for In-Page Anchors & Ticker Link
  document.querySelectorAll('a[href^="#"], a[href^="/#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      const hashIndex = href.indexOf('#');
      if (hashIndex !== -1) {
        const targetId = href.substring(hashIndex + 1);
        if (targetId && targetId !== '') {
          const targetEl = document.getElementById(targetId) || document.querySelector(`[id="${targetId}"]`);
          if (targetEl) {
            // If on the same page, scroll smoothly with sticky header offset
            if (window.location.pathname === '/' || window.location.pathname === '' || !href.startsWith('/') || href.startsWith('/#')) {
              e.preventDefault();
              const headerEl = document.getElementById('mainHeader');
              const tickerEl = document.getElementById('camoTickerBar');
              const offset = (headerEl ? headerEl.offsetHeight : 76) + (tickerEl ? tickerEl.offsetHeight : 34) + 16;
              const elementPosition = targetEl.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.pageYOffset - offset;

              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
              });

              if (history.pushState) {
                history.pushState(null, null, `#${targetId}`);
              } else {
                location.hash = `#${targetId}`;
              }
            }
          }
        }
      }
    });
  });

  // Legacy Announcement Bar Slider Loop Support
  const announcementSlider = document.getElementById('announcementSlider') || document.querySelector('.announcement-slider');
  if (announcementSlider) {
    const slides = announcementSlider.querySelectorAll('.announcement-slide');
    if (slides.length > 1) {
      let currentAnnounce = 0;
      setInterval(() => {
        currentAnnounce = (currentAnnounce + 1) % slides.length;
        const slideH = slides[0].offsetHeight || 36;
        announcementSlider.style.transform = `translateY(-${currentAnnounce * slideH}px)`;
      }, 3500);
    }
  }

  // Checkout Button Action
  const checkoutBtn = document.getElementById('checkoutBtn');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const isRitual = (CAMO_LIVE_CART.is_ritual_applied || CAMO_LIVE_CART.discount_code === 'RITUAL15' || CAMO_LIVE_CART.discount_code === 'CAMO15' || (CAMO_LIVE_CART.items && CAMO_LIVE_CART.items.length >= 3));
      const targetDiscount = isRitual ? 'RITUAL15' : (CAMO_LIVE_CART.discount_code || '');

      if (typeof window !== 'undefined' && window.CAMO_WP && window.CAMO_WP.checkout_url) {
        window.location.href = window.CAMO_WP.checkout_url;
      } else if (targetDiscount) {
        window.location.href = `/discount/${targetDiscount}?redirect=/checkout`;
      } else {
        window.location.href = '/checkout';
      }
    });
  }

  // Promo Code Button Action
  const applyPromoBtn = document.getElementById('applyPromoBtn');
  const promoInput = document.getElementById('promoCodeInput');
  if (applyPromoBtn && promoInput) {
    applyPromoBtn.addEventListener('click', () => {
      const code = (promoInput.value || '').trim().toUpperCase();
      if (!code) {
        camoShowToast('Introduce un código de descuento');
        return;
      }
      if (code === 'CAMO10' || code === 'BIENVENIDA10') {
        CAMO_LIVE_CART.discount_code = code;
        CAMO_LIVE_CART.discount_percent = 10;
        camoShowToast(`✓ Cupón ${code} del 10% aplicado con éxito`);
        camoRenderCart();
      } else if (code === 'RITUAL15' || code === 'CAMO15') {
        CAMO_LIVE_CART.is_ritual_applied = true;
        CAMO_LIVE_CART.discount_code = code;
        CAMO_LIVE_CART.discount_percent = 15;
        camoShowToast(`✓ Cupón especial de Ritual 15% aplicado`);
        camoRenderCart();
      } else {
        camoShowToast('Código de descuento no válido o caducado');
      }
    });
  }

  // Initial Cart Fetch & Wishlist Render
  camoFetchLiveCart(false);
  camoPreloadShopifyVariants();
  camoRenderWishlist();
});

// ==========================================================================
// LUXURY PRODUCT GALLERY ZOOM & FULLSCREEN LIGHTBOX
// ==========================================================================
window.camoZoomImage = function(event, cardEl) {
  if (!cardEl) return;
  const imgEl = cardEl.querySelector('.camo-vertical-img') || cardEl;
  if (!imgEl) return;
  const rect = cardEl.getBoundingClientRect();
  const x = Math.max(0, Math.min(100, ((event.clientX - rect.left) / rect.width) * 100));
  const y = Math.max(0, Math.min(100, ((event.clientY - rect.top) / rect.height) * 100));
  
  imgEl.style.transformOrigin = `${x}% ${y}%`;
  imgEl.style.transform = 'scale(2.2)';
};

window.camoResetZoom = function(cardEl) {
  if (!cardEl) return;
  const imgEl = cardEl.querySelector('.camo-vertical-img') || cardEl;
  if (!imgEl) return;
  imgEl.style.transformOrigin = 'center center';
  imgEl.style.transform = 'scale(1)';
};

window.camoOpenImageModal = function(imageSrc, imageAlt) {
  if (!imageSrc) return;
  let modal = document.getElementById('camoImageLightboxModal');
  if (!modal) {
    modal = document.createElement('div');
    modal.id = 'camoImageLightboxModal';
    modal.className = 'camo-lightbox-modal';
    modal.innerHTML = `
      <div class="camo-lightbox-backdrop" onclick="window.camoCloseImageModal()"></div>
      <div class="camo-lightbox-container">
        <button type="button" class="camo-lightbox-close" onclick="window.camoCloseImageModal()" aria-label="Cerrar ampliación">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
        <div class="camo-lightbox-image-wrap">
          <img id="camoLightboxImg" src="" alt="" class="camo-lightbox-img" />
        </div>
        <p id="camoLightboxCaption" class="camo-lightbox-caption"></p>
      </div>
    `;
    document.body.appendChild(modal);
    
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') window.camoCloseImageModal();
    });
  }

  const imgEl = document.getElementById('camoLightboxImg');
  const captionEl = document.getElementById('camoLightboxCaption');
  if (imgEl) {
    imgEl.src = imageSrc;
    imgEl.alt = imageAlt || 'Detalle de producto CAMO Cosmetics';
  }
  if (captionEl) {
    captionEl.textContent = imageAlt || '';
  }

  modal.classList.add('is-active');
  document.body.style.overflow = 'hidden';
};

window.camoCloseImageModal = function() {
  const modal = document.getElementById('camoImageLightboxModal');
  if (modal) {
    modal.classList.remove('is-active');
  }
  document.body.style.overflow = '';
};

// Bind to window.camoApp namespace as well
window.camoApp = window.camoApp || {};
window.camoApp.zoomImage = window.camoZoomImage;
window.camoApp.resetZoom = window.camoResetZoom;
window.camoApp.openImageModal = window.camoOpenImageModal;
window.camoApp.closeImageModal = window.camoCloseImageModal;
window.camoApp.copyCoupon = window.camoCopyCoupon;
window.camoApp.addBundleToCart = window.camoAddBundleToCart;
window.camoApp.toggleBundleCard = window.camoToggleBundleCard;

